export const inspections = {
shared: {
  jobVisibility: {
    contractors: "المقاولون",
    team: "الفريق",
    private: "خاص",
  },
  jobCategory: {
    Other: "أخرى",
    Cleaning: "تنظيف",
    Installation: "تركيب",
    Replacement: "استبدال",
    Inspection: "فحص",
    Maintenance: "صيانة",
    Repair: "إصلاح",
  },
checklistCategory: {
Inspection: "فحص",
Check: "تحقق",
Audit: "تدقيق",
SafetyReview: "مراجعة السلامة",
Maintenance: "صيانة",
General: "عام",
},
itemsAnswered_zero: "عناصر مُجاب عنها: {{value}} من {{count}} ({{percent}}٪)",
itemsAnswered_one: "عناصر مُجاب عنها: {{value}} من {{count}} ({{percent}}٪)",
itemsAnswered_two: "عناصر مُجاب عنها: {{value}} من {{count}} ({{percent}}٪)",
itemsAnswered_few: "عناصر مُجاب عنها: {{value}} من {{count}} ({{percent}}٪)",
itemsAnswered_many: "عناصر مُجاب عنها: {{value}} من {{count}} ({{percent}}٪)",
itemsAnswered_other: "عناصر مُجاب عنها: {{value}} من {{count}} ({{percent}}٪)",
workflowRationale: {
explicit: "مختار لهذا الفحص.",
lastUsed: "آخر ما استُخدم لهذا الأصل.",
bestMatch: "أنسب سير عمل متوافق مع نوع هذا الأصل.",
history: "استنادًا إلى آخر {{inspections}} لهذا الأصل ({{every}}).",
historyInspections_zero: "{{count}} فحص",
historyInspections_one: "فحص واحد",
historyInspections_two: "فحصين",
historyInspections_few: "{{count}} فحوصات",
historyInspections_many: "{{count}} فحصًا",
historyInspections_other: "{{count}} فحص",
historyEvery_zero: "كل يوم تقريبًا",
historyEvery_one: "كل يوم تقريبًا",
historyEvery_two: "كل يومين تقريبًا",
historyEvery_few: "كل {{count}} أيام تقريبًا",
historyEvery_many: "كل {{count}} يومًا تقريبًا",
historyEvery_other: "كل {{count}} يوم تقريبًا",
assetTypeDefault: {
car: "وتيرة البدء المعتادة لأصول المركبات — عدّلها حسب الحاجة.",
property: "وتيرة البدء المعتادة لأصول العقارات — عدّلها حسب الحاجة.",
equipment: "وتيرة البدء المعتادة لأصول المعدات — عدّلها حسب الحاجة.",
other: "وتيرة البدء المعتادة للأصول الأخرى — عدّلها حسب الحاجة.",
},
},
executionMode: {
list: "قائمة",
guidedGroup: "موجَّه حسب المجموعة",
guidedItem: "موجَّه حسب العنصر",
},
recordStatus: {
inProgress: "قيد التنفيذ",
paused: "متوقف مؤقتًا",
submitted: "مُرسَل",
approved: "معتمد",
completed: "مكتمل",
cancelled: "ملغى",
},
},
start: {
  planningLoadErrorTitle: "تعذر فتح التخطيط",
  planningAssetUnavailable: "هذا الأصل غير متاح، أو لم تعد لديك صلاحية الوصول إليه.",
  planningAssetMismatch: "هذا الطلب يخص أصلًا آخر. افتح الطلب وحاول مرة أخرى.",
  planningLoading: "جارٍ التجهيز…",
  planningTitle: "تخطيط العمل",
setupRequiredTitle: "الإعداد مطلوب",
setupRequiredBodyAll: "أضف أصلًا واحدًا على الأقل وقائمة تحقق واحدة قبل بدء التفتيش.",
setupRequiredBodyAssets: "أضف أصلًا واحدًا على الأقل قبل بدء التفتيش.",
setupRequiredBodyTemplates: "أنشئ قائمة تحقق واحدة على الأقل قبل بدء التفتيش.",
addAsset: "إضافة أصل",
createChecklist: "إنشاء قائمة تحقق",
createChecklistA11y: "إنشاء قائمة تحقق",
createChecklistSheetTitle: "إنشاء قائمة تحقق",
createChecklistSheetSubtitle: "اختر طريقة إنشاء قائمة التحقق.",
createChecklistWithAi: "إنشاء بالذكاء الاصطناعي",
createChecklistManually: "إنشاء يدويًا",
overlayReturnFootnote: "يُفتح في نافذة علوية. عند الحفظ، تعود إلى هنا للبدء أو الجدولة.",
stepSelectAsset: "1. اختيار الأصل",
searchAssetsPlaceholder: "البحث في الأصول",
searchAssetsA11y: "البحث في الأصول",
allTypesA11y: "إظهار جميع أنواع الأصول",
tapSelectedAssetToChange: "اضغط على الأصل المحدد لتغييره.",
noAssetsMatch: "لا توجد أصول مطابقة لبحثك.",
stepSelectChecklist: "2. اختيار قائمة التحقق",
noChecklistsForAssetType: "لا توجد قوائم تحقق مطابقة لنوع الأصل {{assetType}}.",
selectAssetFirst: "اختر أصلًا أولًا لعرض قوائم التحقق المتوافقة.",
searchChecklistsPlaceholder: "البحث في قوائم التحقق",
searchChecklistsA11y: "البحث في قوائم التحقق",
showingChecklistsFor: "عرض قوائم التحقق لـ {{assetType}}",
tapSelectedChecklistToChange: "اضغط على قائمة التحقق المحددة لتغييرها.",
noChecklistsMatch: "لا توجد قوائم تحقق مطابقة لبحثك.",
stepAssignInspector: "3. التعيين والبدء",
youSuffix: " (أنت)",
you: "أنت",
onlyTeamMember: "عضو فريقك الوحيد متاح الآن.",
createTeamToAssign: "أنشئ فريقًا لتعيين التفتيشات لآخرين.",
executionModeLabel: "نمط التنفيذ",
locationTitle: "الموقع الحالي",
locationLoading: "جارٍ التحقق من موقعك...",
locationNotSupported: "الموقع غير مدعوم على هذا الجهاز.",
locationPermissionDenied: "تم رفض إذن الموقع.",
locationUnavailableFallback: "الموقع غير متاح.",
locationUnavailableMessage: "الموقع غير متاح: {{reason}}",
starting: "جارٍ البدء...",
startInspection: "بدء التفتيش",
prefilledMomentumHint: "راجع الاختيارات أدناه، ثم اضغط بدء التفتيش.",
scheduleForLater: "جدولة لوقت لاحق",
noPriority: "بلا أولوية",
requestContextEyebrow: "تفتيش لطلب",
requesterNotSet: "غير محدد",
requestHandoff: {
requesterFallback: "مقدّم الطلب",
decisionStartNow: "القرار: البدء الآن",
},
alerts: {
selectAsset: "اختر أصلًا قبل الاستمرار.",
selectChecklist: "اختر قائمة تحقق قبل الاستمرار.",
selectAssetAndChecklist: "اختر أصلًا وقائمة تحقق للبدء.",
assetArchivedTitle: "أصل مؤرشف",
assetArchivedBody: "لا يمكن تفتيش الأصول المؤرشفة. اختر أصلًا آخر.",
assetArchivedScheduleBody: "لا يمكن جدولة تفتيش للأصول المؤرشفة. اختر أصلًا آخر.",
couldNotStartTitle: "تعذّر بدء التفتيش",
couldNotStartBody: "يرجى المحاولة مرة أخرى.",
},
},
share: {
title: "مشاركة التقرير",
},
report: {
coverEyebrow: "تقرير الحالة",
coverUntitled: "أصل بلا عنوان",
sectionSubject: "الموضوع",
statInspected: "تم تفتيشه",
statRepairs: "الإصلاحات",
statEstTotal: "الإجمالي التقديري",
},
sentForApproval: {
subtitle: "سنرسل رابط مراجعة بالبريد الإلكتروني. سنُعلمك عند الرد.",
backToHome: "العودة إلى الرئيسية",
viewReport: "عرض التقرير",
},
detail: {
  sendBack: {
    errors: {
      notAllowed: "يمكن فقط لمن يعتمد العمل على هذا الأصل إعادته.",
      notWaiting: "لم يعد هذا الفحص بانتظار الاعتماد. ربما اعتمده أحدهم أو أعاده للتو.",
      ownWork: "لا يمكنك إعادة فحص أجريته بنفسك.",
      reasonRequired: "اكتب بين 3 و1000 حرف ليعرف ما يجب إصلاحه.",
    },
    noticeHint: "أصلح ما طُلب، ثم اضغط «إكمال الفحص» مرة أخرى. سيعود إليه للاعتماد.",
    noticeReason: "«{{reason}}»",
    noticeTitle: "أعاد {{name}} هذا الفحص",
    approverFallback: "المعتمِد",
    inspectorFallback: "المفتش",
    failedTitle: "تعذّرت الإعادة",
    sent: "أُعيد إلى {{name}}. سيرى سببك.",
    sending: "جارٍ الإعادة…",
    confirm: "إعادة للتعديل",
    reasonTooShort: "اكتب بضع كلمات ليعرف ما يجب إصلاحه.",
    reasonPlaceholder: "مثال: أضف صورة لمصرف السطح.",
    reasonLabel: "ما الذي يجب إصلاحه",
    hint: "اذكر ما يجب إصلاحه. يتلقى {{name}} إشعارًا ويُعاد فتح الفحص له.",
    title: "إعادة إلى {{name}}",
    buttonA11y: "إعادة هذا الفحص إلى {{name}} مع ذكر السبب",
    button: "إعادة للتعديل",
  },
  errors: {
    completeTitle: "تعذر إكمال الفحص",
    deleteTitle: "تعذر حذف الفحص",
    continueTitle: "تعذرت متابعة الفحص",
    takeOverTitle: "تعذر إنجاز ذلك نيابة عنهم",
    reopenTitle: "تعذرت إعادة فتح الفحص",
    approveTitle: "تعذرت الموافقة على الفحص",
    suggestionTitle: "تعذرت إضافة هذا الاقتراح",
    reloadTitle: "تعذر تحميل نسختهم",
    mergeTitle: "تعذر الاحتفاظ بإجاباتك",
    checkConnection: "تحقق من اتصالك وحاول مرة أخرى.",
  },
  outline: {
    title: "البنود · {{done}} من {{total}} تمت الإجابة عنها",
    jumpA11y: "الانتقال إلى البند {{n}}، {{label}}، {{state}}",
    state: { failed: "غير مطابق", done: "تمت الإجابة", skipped: "تم تخطيه", pending: "لم تتم الإجابة بعد" },
  },
findingsNextActionsTitle: "النتائج والإجراءات التالية",
assetContext: {
asset: "أصل",
previousOnThisAsset: "السابق على هذا الأصل",
manuals: "الأدلة",
noAssetLinked: "لا يوجد أصل مرتبط",
openAsset: "فتح الأصل ←",
openAssetA11y: "فتح الأصل",
},
approval: {
  fixAndResend: "إصلاح وإعادة الإرسال",
  fixHint: "أصلح ما طُلب، ثم أرسل التقرير مرة أخرى.",
  changesAskedNoReason: "طلب {{name}} تعديلات.",
  changesAsked: "طلب {{name}} تعديلات: «{{reason}}»",
  linkCopied: "تم نسخ الرابط. الصقه في رسالة إلى {{name}}.",
  sendAgainA11y: "إرسال التقرير إلى {{name}} مرة أخرى",
  sendAgain: "إرسال مرة أخرى",
  sentToDue: "أُرسل إلى {{name}} في {{date}} · الرد قبل {{due}}",
  sentTo: "أُرسل إلى {{name}} في {{date}}",
  summary: {
    nextNotShared: "أكمل الفحص، ثم شارك التقرير إذا كان أحد بحاجة إلى الموافقة عليه.",
    nextWaitingFor: "بانتظار اعتماد {{name}} لهذا الفحص.",
    nextWaitingForTeam: "بانتظار أن يعتمد أحد أعضاء {{name}} هذا الفحص.",
    nextStepWaited_zero: "{{nextStep}}",
    nextStepWaited_two: "{{nextStep}} في الانتظار منذ يومين.",
    nextStepWaited_few: "{{nextStep}} في الانتظار منذ {{count}} أيام.",
    nextStepWaited_many: "{{nextStep}} في الانتظار منذ {{count}} يومًا.",
    nextStepWaited_one: "{{nextStep}} في الانتظار منذ يوم واحد.",
    nextStepWaited_other: "{{nextStep}} في الانتظار منذ {{count}} أيام.",
    nextYouApprove: "راجع النتائج، ثم اضغط اعتماد.",
    nextWaitingShared: "بانتظار رد الشخص الذي شاركته معه.",
    nextResponded: "اقرأ الرد وقرر الخطوة التالية.",
    nextRespondedJobs: "الإصلاحات المعتمدة جاهزة لتصبح مهام.",
    nextChangesRequested: "اقرأ الملاحظات، وحدّث الفحص، ثم شاركه مرة أخرى.",
    nextApproved: "معتمد. افتح الخطوات التالية أو شارك التقرير.",
    nextApprovedJobs: "راجع الإصلاحات المعتمدة، ثم أنشئ المهام لها.",
    noApproverYet: "لا يوجد معتمِد بعد",
    recipientFallback: "المستلم",
    statusNotShared: "غير مشترك",
    statusAwaiting: "بانتظار الاعتماد",
    statusResponded: "تم الرد",
    statusChangesRequested: "طُلبت تغييرات",
    statusApproved: "معتمد",
  },
  askAiDraft: "ساعدني في مراجعة فحص {{checklist}} على {{asset}} بتاريخ {{date}} وتحديد الخطوة التالية.",
  closeIt: "إغلاق",
  keepWaiting: "متابعة الانتظار",
  closeConfirmBody: "لم يرد {{name}}. سيتم تسجيل الإصلاحات المقترحة على أنها غير معتمدة نيابة عنه.",
  closeConfirmTitle: "الإغلاق دون رد؟",
  takeOverSignedOff: "تمت الموافقة بدلًا من {{name}}",
  takeOverClosed: "أُغلق دون رد",
  takeOverApproved: "تمت الموافقة نيابة عن {{name}}",
  teamApprover: "أي عضو في {{name}}",
  assetApprover: "معتمِد الأصل",
  approverFallback: "المعتمِد",
  reopenConfirm: "إعادة الفتح",
  reopenConfirmBody: "يمكنك تغيير الإجابات مرة أخرى، ثم إكمال الفحص من جديد.",
  reopenConfirmApproved: "وافق عليه {{name}}. إعادة الفتح تلغي هذه الموافقة، لذا سيحتاج إلى موافقة جديدة.",
  reopenConfirmTitle: "إعادة فتح هذا الفحص؟",
approval: "موافقة",
statusSummaryA11y: "حالة الموافقة: {{status}}. {{action}}",
collapse: "طي",
showDetails: "إظهار التفاصيل",
currentStatus: "الوضع الحالي",
approver: "المعتمد",
nextStep: "الخطوة التالية",
approveInspectionA11y: "اعتماد هذا الفحص",
approving: "جارٍ الاعتماد…",
approveInspection: "اعتماد",
openNextStepsA11y: "افتح الخطوات التالية",
nextSteps: "الخطوات التالية",
shareReportA11y: "شارك التقرير",
shareReport: "مشاركة التقرير",
reopenAndClearA11y: "أعد فتح هذا الفحص وامسح موافقته",
reopenA11y: "إعادة فتح هذا الفحص",
reopening: "جارٍ إعادة الفتح…",
reopenAndClear: "إعادة الفتح وإلغاء الموافقة",
reopenInspection: "إعادة فتح الفحص",
},
lifecycle: {
pauseTitle: "إيقاف الفحص مؤقتًا",
pauseHint: "أضف سببًا اختياريًا وحدِّد موعد الاستئناف.",
reasonOptional: "السبب (اختياري)",
pauseReasonPlaceholder: "مثال: بانتظار قطع الغيار، أو الحاجة إلى موافقة العميل",
resumeDateOptional: "تاريخ الاستئناف (اختياري)",
selectDate: "اختر التاريخ",
resumeTimeOptional: "وقت الاستئناف (اختياري)",
selectTime24h: "حدد الوقت (24 ساعة)",
cancel: "إلغاء",
pause: "إيقاف مؤقت",
cancelTitle: "إلغاء الفحص",
cancelHint: "يُحفظ التقدّم، لكن سيُعلَّم الفحص على أنه ملغى. يرجى ذكر السبب.",
cancellationReason: "سبب الإلغاء",
cancelReasonPlaceholder: "مثال: بيع الأصل، فحص مكرر، قائمة تحقق خاطئة",
back: "الإبقاء على الفحص",
cancelInspection: "إلغاء الفحص",
reassignTitle: "إعادة إسناد الفحص",
reassigned: "أُعيد إسناده إلى {{name}}. يبقى الفحص قيد التنفيذ لديه.",
reassignFailed: "تعذّرت إعادة إسناد الفحص. حاول مرة أخرى.",
pickContractorTitle: "إسنادها إلى مقاول",
contractorNoAccountTitle: "لا يوجد حساب AssetWRX بعد",
contractorNoAccountBody: "يحتاج {{name}} إلى حساب AssetWRX لتنفيذ الفحص. ادعُه من جهات الاتصال؛ وبعد انضمامه يمكنك إسنادها إليه.",
cancelReasonRequired: "يرجى ذكر سبب الإلغاء.",
cancelledTitle: "أُلغي",
cancelledBody: "تم إلغاء الفحص.",
cancelFailed: "تعذّر إلغاء الفحص. حاول مرة أخرى.",
pauseFailed: "تعذّر إيقاف الفحص مؤقتًا. حاول مرة أخرى.",
errorTitle: "خطأ",
searchTeamMembersPlaceholder: "البحث في أعضاء الفريق…",
noTeamMemberMatch: "لا يوجد عضو فريق مطابق.",
skipTitle: "هل تريد تخطي هذا العنصر؟",
skipHint: "أضف ملاحظة قصيرة إذا كانت تساعد فريقك (اختياري). اضغط على تخطي للتأكيد.",
noteOptional: "ملاحظة (اختياري)",
skipReasonPlaceholder: "على سبيل المثال. لا يمكن الوصول، لا ينطبق",
skip: "تخطي",
},
repair: {
proposedFollowUp: "هل يحتاج إلى مهمة؟",
confirmedAfterCompletion: "(تم التأكيد بعد الإكمال)",
markForFollowUp: "نعم، أنشئ مهمة لهذا",
titleField: "العنوان *",
titlePlaceholder: "مثال: إصلاح تسرب الصنبور",
priority: "الأولوية",
priorityFallback: "متوسط",
description: "الوصف *",
descriptionPlaceholder: "ما الذي يجب فعله...",
descriptionFallback: "بلا",
hideOptionsA11y: "إخفاء خيارات المتابعة",
showOptionsA11y: "عرض المزيد من خيارات المتابعة",
lessOptions: "خيارات أقل",
moreOptions: "المزيد من الخيارات",
repairCategory: "فئة الإصلاح",
repairCategoryFallback: "إصلاح",
skillsOptional: "المهارات (اختياري)",
skills: "المهارات",
selected: "تم التحديد",
none: "بلا",
dueDateOptional: "تاريخ الاستحقاق (اختياري)",
visibility: "الظهور",
visibilityFallback: "خاص",
estimatedCostOptional: "التكلفة المقدرة (اختياري)",
notSet: "غير محدد",
costPlaceholder: "0.00",
requiresUrgentRepair: "يتطلب إصلاحًا عاجلاً",
urgentRepairNoteLabel: "ملاحظة إصلاح عاجلة",
noNote: "لا ملاحظة",
markFollowUpHintPrefix: "بعد إكمال الفحص، ستؤكد هذه المهمة في ",
markFollowUpHintSuffix: " قبل إنشائها.",
},
urgentNote: {
placeholder: "لماذا هذا عاجل؟",
stop: "إيقاف",
dictate: "إملاء",
cleaningUpEllipsis: "جارٍ التنظيف...",
aiCleanUp: "تنظيف بالذكاء الاصطناعي",
addNoteFirstTitle: "أضف ملاحظة أولاً",
addNoteFirstBody: "اكتب ملاحظة قصيرة قبل استخدام التنظيف بالذكاء الاصطناعي.",
cleaningUp: "جارٍ تحسين الملاحظة العاجلة",
unableToCleanUpTitle: "غير قادر على تنظيف الملاحظة",
cleanedUpTitle: "الملاحظة العاجلة بعد التحسين",
reviewSuggestedWording: "راجع الصياغة المقترحة قبل تطبيقها.",
},
followUpModal: {
eyebrow: "إجراء الفحص",
title: "هل يحتاج إلى مهمة؟",
closeA11y: "إغلاق المتابعة",
saveHint: "حدّدها، ثم أكمل الفحص. ستؤكد المهمة قبل إنشائها.",
doneEditingA11y: "الانتهاء من تحرير المتابعة المقترحة",
done: "تم",
},
imageFindingsOverlay: {
findingA11y: "النتيجة: {{label}}",
confidenceSeverity: "الثقة: {{confidence}}% · الخطورة: {{severity}}",
removeMarkerA11y: "إزالة علامة النتيجة",
removeMarker: "قم بإزالة العلامة",
close: "إغلاق",
},
quickRating: {
quickRatingA11y: "تقييم سريع",
yes: "نعم",
no: "لا",
quickLevelA11y: "مستوى سريع",
conditionRatingA11y: "تصنيف الحالة",
},
imageViewer: {
couldNotLoad: "تعذر تحميل الصورة",
closeA11y: "إغلاق عارض الصور",
},
noteSheet: {
eyebrow: "ملاحظة الفحص",
title: "إضافة ملاحظة",
closeA11y: "إغلاق الملاحظة",
hint: "اكتبها، أو أملِها وستُضاف إلى الملاحظة نفسها.",
placeholder: "إضافة ملاحظات الفحص...",
dictateStop: "إيقاف الإملاء",
dictateFinishing: "جارٍ الإنهاء…",
dictateUnavailable: "الإملاء غير متاح",
dictateIdle: "إملاء",
doneA11y: "تم",
done: "تم",
},
imageAnalysis: {
coverage: {
observed: "ظاهر",
partial: "ظاهر جزئيًا",
not_observed: "غير ظاهر: أجب يدويًا",
},
analysePhoto: "تحليل الصورة بالذكاء الاصطناعي",
analysePhotoA11y: "تحليل الصورة بالذكاء الاصطناعي",
aiQueued: "تحليل الذكاء الاصطناعي في قائمة الانتظار",
photoAnalysisTitle: "تحليل الصورة",
analysing: "جارٍ التحليل...",
suggestedComment: "التعليق المقترح",
severity: "الخطورة: {{severity}}",
status: "الحالة: {{status}}",
findings: "نتائج",
appendToComments: "إلحاق بالتعليقات",
replaceComments: "استبدال التعليقات",
ignore: "تجاهل",
removeFindingA11y: "إزالة النتيجة {{label}}",
remove: "إزالة",
replaceConfirmTitle: "هل تريد استبدال التعليقات؟",
replaceConfirmBody: "سيؤدي هذا إلى استبدال ملاحظتك الحالية باقتراح الذكاء الاصطناعي.",
replaceConfirmCancel: "إلغاء",
replaceConfirmReplace: "استبدال",
},
runnerHeader: {
doneCount: "{{completed}}/{{total}} منجز",
failCount: "{{count}} للمتابعة",
urgentCountLabel_zero: "{{count}} عاجل",
urgentCountLabel_one: "{{count}} عاجل",
urgentCountLabel_two: "{{count}} عاجل",
urgentCountLabel_few: "{{count}} عاجل",
urgentCountLabel_many: "{{count}} عاجل",
urgentCountLabel_other: "{{count}} عاجل",
modeLabel: {
list: "قائمة",
guidedGroup: "حسب المجموعة",
guidedItem: "حسب العنصر",
},
modeDesc: {
list: "كل العناصر دفعة واحدة",
guidedGroup: "مجموعة واحدة في كل مرة",
guidedItem: "عنصر واحد في كل مرة",
},
cancelled: "ملغى",
paused: "متوقف مؤقتًا",
sectionEyebrow: "القسم {{index}} من {{count}}",
openAssetA11y: "افتح {{assetName}}",
openSyncConflictA11y: "فتح خيارات تعارض المزامنة",
retrySaveA11y: "أعد محاولة حفظ إجابات الفحص",
review: "المراجعة",
retry: "إعادة المحاولة",
askAiCompactA11y: "بناءً على إجاباتك، يمكن للذكاء الاصطناعي المساعدة في عمليات الفحص التالية",
askAiWideA11y: "يمكن للذكاء الاصطناعي المساعدة في عمليات الفحص التالية",
jumpToIncompleteA11y: "انتقل إلى العنصر التالي غير المكتمل المطلوب",
jumpToIncomplete: "انتقل إلى غير مكتمل",
changeModeA11y: "تغيير وضع العرض. الحالي: {{mode}}",
viewAsTitle: "طريقة عرض هذا الفحص",
modeOptionA11y: "{{mode}}: {{desc}}",
viewModeAction: "العرض: {{mode}}",
viewModeTooltip: "قم بتغيير كيفية عرض قائمة التحقق",
},
},
overview: {
statusApproved: "تمت الموافقة",
statusCompleted: "مكتمل",
statusCancelled: "ملغى",
statusPaused: "متوقف مؤقتًا",
statusInProgress: "قيد التنفيذ",
items: "العناصر",
progress: "التقدم",
failures: "الإخفاقات",
urgent: "عاجل",
resumeLabel: "الاستئناف: {{text}}",
operationalTimelineA11y_one: "الجدول الزمني التشغيلي، حدث واحد",
operationalTimelineA11y_other: "الجدول الزمني التشغيلي، {{count}} حدث",
operationalTimelineTitle: "الجدول الزمني للعمليات · {{count}}",
whoLabel: "من: {{actor}}",
whenLabel: "متى: {{when}}",
operationalTimelineA11y_zero: "الجدول الزمني التشغيلي، لا أحداث",
operationalTimelineA11y_two: "الجدول الزمني التشغيلي، حدثان",
operationalTimelineA11y_few: "الجدول الزمني التشغيلي، {{count}} أحداث",
operationalTimelineA11y_many: "الجدول الزمني التشغيلي، {{count}} حدثًا",
},
photoEvidence: {
photos: "الصور",
mediaGuidance: "ما يصل إلى 3 صور لكل عنصر · ارسم لتسليط الضوء عليها قبل الحفظ.",
noPhotosTaken: "لم يتم التقاط أي صور",
evidencePhotoA11y: "{{label}} — صورة الدليل {{index}} من {{count}}. عرض بالحجم الكامل",
},
shareSection: {
  statusChanges: "طُلبت تعديلات",
  statusApproved: "تمت الموافقة",
  statusWaiting: "قيد الانتظار",
  messageA11y: "فتح المراجعة مع {{name}}",
reportSharedWith: "تمت مشاركة التقرير مع",
message: "رسالة",
createJobs: "إنشاء مهام",
revoke: "إلغاء",
revokeAccessA11y: "إبطال الوصول إلى التقرير لـ {{name}}",
revokeConfirmTitle: "هل تريد إلغاء الوصول إلى التقرير؟",
revokeConfirmBody: "لن يتمكن {{name}} من فتح رابط التقرير بعد الآن. يتم الاحتفاظ بسجل المشاركة.",
revokeConfirmCancel: "إلغاء",
revokeConfirmConfirm: "إلغاء الوصول",
revokeFailedTitle: "تعذر إلغاء الوصول",
revokeFailedBody: "يرجى المحاولة مرة أخرى بعد قليل.",
recipientFallback: "هذا المستلم",
},
checklistSection: {
batchHintRange: "العناصر {{from}}–{{to}} من {{total}}",
prefillNotice: "الفحص السابق{{dateSuffix}}. تُعرض نتائج وملاحظات المرة السابقة للرجوع إليها. سجّل النتيجة الحالية لكل فحص.",
prefillNoticeDateSuffix: " بتاريخ {{date}}",
emptyGroup: "لا يوجد شيء يمكن إكماله في هذه المجموعة.",
},
evidenceRail: {
collapseA11y: "طي {{title}}",
hide: "إخفاء",
},
swipeableWrap: {
ok: "حسنًا",
skip: "تخطي",
},
kpis: {
items: "العناصر",
status: "الحالة",
cost: "التكلفة التقديرية",
reviews: "المراجعات",
percentDone: "{{percent}}٪ منجز",
statusInProgress: "قيد التنفيذ",
},
summaryCard: {
  suggestedTitle: "ملخص مقترح",
title: "ملخص الفحص",
editSummary: "تعديل الملخص",
noSummaryYet: "لا يوجد ملخص بعد",
generatedAt: "أُنشئ في {{date}}",
regenerate: "إعادة الإنشاء",
generate: "إنشاء",
generating: "جارٍ الإنشاء...",
buildingSummary: "جارٍ إعداد الملخص من بيانات الفحص...",
noCredits: "لم يتبقَّ رصيد استخدام، لذا لا يمكن كتابة الملخص. اشترِ حزمة رصيد أو انتظر رصيدك الشهري المضمّن.",
noCreditsMember: "لم يتبقَّ رصيد استخدام، لذا لا يمكن كتابة الملخص. اطلب من مسؤول مساحة العمل شراء رصيد، أو انتظر رصيدك الشهري المضمّن.",
noCreditsOnDevice: "لم يتبقَّ رصيد استخدام، لذا لا يمكن كتابة الملخص. يُشترى الرصيد من AssetWRX على الويب، أو يصل مع رصيدك الشهري المضمّن.",
topUp: "شراء رصيد",
},
valueAnswer: {
readingLabel: "قراءة",
textLabel: "الإجابة",
textPlaceholder: "اكتب أو امسح",
scan: "مسح",
detected: "تم الاكتشاف: {{value}}",
detectedOnDevice: "قُرئ على هذا الجهاز، دون استخدام أرصدة الذكاء الاصطناعي",
use: "استخدام",
ignore: "تجاهل",
},
checklistEditor: {
required: "مطلوب",
yes: "نعم",
no: "لا",
ratingReading: "قراءة",
ratingText: "نص",
meterLabel: "العداد",
meterHintMissing: "اختر العداد المقصود. عندها فقط تُضاف القراءة إلى سجل عداد الأصل عند إكمال الفحص.",
meterHintUnit: "أضف الوحدة (مثل bar أو °C) حتى يمكن إضافة القراءة إلى سجل عداد الأصل.",
meterHintSaved: "تُضاف إلى قراءات «{{meter}}» للأصل عند إكمال الفحص، وتُحتسب في الصيانة المعتمدة على العداد.",
meterHours: "ساعات",
meterDistance: "المسافة",
meterCycles: "دورات",
meterOther: "أخرى",
unitLabel: "الوحدة",
visionCanAssist: "يمكن لـ Vision الإجابة من صورة",
useVision: "مسح هذا القسم باستخدام Vision",
visionOff: "إيقاف",
visionAvailable: "متاح",
visionRecommended: "موصى به",
evidenceAlways: "يُتوقع دليل مصوّر",
evidenceOnFail: "يُتوقع دليل مصوّر عند الفشل",
measureLabel: "القياس",
ratingCondition: "الحالة",
ratingLevel: "المستوى",
ratingYesNo: "نعم/لا",
ratingPassFailNa: "نجاح/فشل/غير منطبق",
ratingPassFlagFail: "نجاح/تنبيه/فشل",
failWhenLabel: "تفشل عندما",
yesNoFailHint: "استخدم \"نعم\" للأسئلة التي تسأل عن وجود مشكلة (مثال: \"هل توجد تشققات؟\"). استخدم \"لا\" لأسئلة الامتثال (مثال: \"هل تم تركيب الواقي؟\").",
captureLabel: "الالتقاط",
images: "صور",
videos: "فيديوهات",
groupNameA11y: "اسم المجموعة",
groupNamePlaceholder: "اسم المجموعة",
itemLabelA11yIndexed: "تسمية العنصر {{index}}",
itemLabelPlaceholder: "تسمية العنصر",
itemDescriptionA11yIndexed: "وصف العنصر {{index}} (اختياري)",
descriptionOptionalPlaceholder: "الوصف (اختياري)",
addItemToGroup: "إضافة عنصر إلى المجموعة",
moveUpA11y: "نقل لأعلى",
moveDownA11y: "نقل لأسفل",
removeGroupA11y: "إزالة المجموعة",
removeItemA11y: "إزالة العنصر",
dragA11y: "إعادة الترتيب: اضغط مطولاً ثم اسحب",
itemLabelA11y: "تسمية العنصر",
itemLabelPlaceholderExample: "تسمية العنصر (مثال: فحص زيت المحرك)",
itemDescriptionA11y: "وصف العنصر (اختياري)",
requiredNeedsOneItem: "تحتاج القائمة المرجعية إلى عنصر واحد على الأقل.",
groupDefaultLabel: "المجموعة {{number}}",
inspectionNotFoundTitle: "الفحص غير موجود",
couldNotLoadItemsBody: "تعذر تحميل هذا الفحص لنسخ العناصر.",
noItemsToCopyTitle: "لا توجد عناصر لنسخها",
noItemsToCopyBody: "لا يحتوي هذا الفحص على عناصر قائمة مرجعية لاستخدامها كقائمة تحقق.",
couldNotLoadInspectionTitle: "تعذر تحميل الفحص",
tryAgainOrCreateManually: "حاول مرة أخرى أو أنشئ قائمة التحقق يدويًا.",
workflowCopySuffix: "{{name}} (نسخة سير العمل)",
unsavedTemplateMessage: "لم يتم حفظ قائمة التحقق هذا بعد. هل تريد المغادرة وفقدانه؟",
    unsavedEditsMessage: "لديك تعديلات غير محفوظة في قائمة التحقق هذه. هل تريد المغادرة وفقدانها؟",
    createFailed: "تعذّر إنشاء قائمة التحقق.",
    updateFailed: "تعذّر تحديث قائمة التحقق.",
unsavedTemplateEditMessage: "يحتوي قائمة التحقق هذا على تغييرات غير محفوظة. هل تريد المغادرة وفقدانها؟",
templateNameLabel: "اسم قائمة التحقق *",
templateNameA11y: "اسم قائمة التحقق (مطلوب)",
templateNamePlaceholder: "على سبيل المثال. فحص السيارة قبل الشراء",
generateDraft: "إنشاء مسودة",
templateDetailsTitle: "تفاصيل قائمة التحقق وإمكانية رؤيته",
templateDetailsSummary: "توافق الأصول والوصف والفئات ورؤية الفريق.",
assetTypeCompatibility: "التوافق مع نوع الأصل",
assetTypeHint: "حدد نوع أصل واحد ينطبق عليه هذا قائمة التحقق. اتركه فارغًا لأي نوع.",
customTypesLabel: "أنواع الأصول الخاصة بك",
customTypesHint: "اختر أنواعًا لاستخدام قائمة التحقق هذه لها فقط. اتركها فارغة لكل أصل من الصنف المحدد أعلاه.",
placeTypesLabel: "أنواع الأماكن",
placeTypesHint: "اختر أنواع أماكن مثل الغرفة لاستخدام قائمة التحقق هناك فقط. اتركها فارغة لكل الأماكن.",
any: "أي",
visibilityLabel: "الظهور",
visibilityAllTeams: "يمكن لجميع الفرق في الحساب استخدام هذا قائمة التحقق",
visibilityOnlySelectedTeams: "الفرق المحددة فقط (الافتراضي: فريقك الحالي)",
visibilityCreateTeamHint: "قم بإنشاء فريق في الحساب لتقييد الرؤية",
descriptionHint: "ملخص قصير عند اختيار هذا قائمة التحقق. خياري.",
descriptionPlaceholderExample: "مثال: فحص السيارة قبل الشراء",
categoriesLabel: "الفئات",
categoriesHint: "حدد فئة واحدة أو أكثر",
checklistItemsTitle: "عناصر قائمة التحقق",
addGroup: "إضافة مجموعة",
addItem: "إضافة عنصر",
saveChecklist: "حفظ قائمة التحقق",
templateStructureTitle: "بنية قائمة التحقق",
evidenceCoverageTitle: "تغطية الأدلة",
evidenceCoverageCopy_one: "يلتقط عنصر واحد حاليًا نوع دليل واحدًا على الأقل.",
evidenceCoverageCopy_other: "يلتقط {{count}} عنصر حاليًا نوع دليل واحدًا على الأقل.",
versioningTitle: "الإصدارات",
versioningCopy: "تُحفظ تغييراتك كإصدار جديد. تحتفظ الفحوصات التي بدأت بقائمة التحقق التي بدأت بها.",
newTemplateTitle: "قائمة تحقق فحص جديد",
templateNotFound: "قائمة التحقق غير موجود",
loadingTemplate: "جارٍ تحميل قائمة التحقق…",
startTemplateTitle: "ابدأ إنشاء قائمة التحقق",
startTemplateBody: "أضف أول عنصر أو مجموعة يجب أن يمر بها المفتش. أو استخدم الذكاء الاصطناعي لإنشاء مسودة.",
addFirstItem: "أضف العنصر الأول الخاص بك",
addAGroup: "إضافة مجموعة",
validationTitle: "التحقق من الصحة",
failedToCreateChecklist: "فشل إنشاء قائمة التحقق.",
failedToUpdateChecklist: "فشل تحديث قائمة التحقق.",
editTemplateTitle: "تحرير قائمة التحقق",
saveChanges: "حفظ التغييرات",
evidenceCoverageCopy_zero: "لا عناصر تلتقط حاليًا أي نوع دليل.",
evidenceCoverageCopy_two: "يلتقط عنصران حاليًا نوع دليل واحدًا على الأقل.",
evidenceCoverageCopy_few: "تلتقط {{count}} عناصر حاليًا نوع دليل واحدًا على الأقل.",
evidenceCoverageCopy_many: "يلتقط {{count}} عنصرًا حاليًا نوع دليل واحدًا على الأقل.",
},
checklistDetail: {
loadErrorTitle: "تعذر تحميل هذا قائمة التحقق",
categoryGeneral: "عام",
versionLabel: "الإصدار v{{version}}",
updatedDate: "تم تحديث {{date}}",
currentVersionIdLabel: "معرف الإصدار الحالي:",
versionIdNotSet: "غير محدد",
assetTypesLabel: "أنواع الأصول:",
allAssetTypesShort: "الكل",
scopeLabel: "النطاق:",
versionRowLabel: "الإصدار:",
versionRowValue: "{{version}}",
createdRowLabel: "تاريخ الإنشاء:",
updatedRowLabel: "آخر تحديث:",
selectedTeamsOnly: "الفرق المحددة فقط",
structureLabel: "الهيكل:",
groupsCount_one: "{{count}} مجموعة",
groupsCount_other: "{{count}} مجموعة",
itemsCount_one: "{{count}} عنصر",
itemsCount_other: "{{count}} عنصر",
requiredCountSuffix_zero: "، {{count}} مطلوب",
requiredCountSuffix_one: "، {{count}} مطلوب",
requiredCountSuffix_two: "، {{count}} مطلوب",
requiredCountSuffix_few: "، {{count}} مطلوب",
requiredCountSuffix_many: "، {{count}} مطلوب",
requiredCountSuffix_other: "، {{count}} مطلوب",
useTemplateForInspectionA11y: "استخدام قائمة التحقق للفحص",
itemsCountTitle: "العناصر · {{count}}",
required: "مطلوب",
ungrouped: "غير مجمعة",
groupsCount_zero: "لا مجموعات",
groupsCount_two: "مجموعتان",
groupsCount_few: "{{count}} مجموعات",
groupsCount_many: "{{count}} مجموعة",
itemsCount_zero: "لا عناصر",
itemsCount_two: "عنصران",
itemsCount_few: "{{count}} عناصر",
itemsCount_many: "{{count}} عنصرًا",
},
suggestScreen: {
  partialCreatedBody_other: "تم إنشاء {{count}} مهمة من {{total}}. تعذر إنشاء «{{title}}». حاول مرة أخرى.",
  partialCreatedBody_many: "تم إنشاء {{count}} مهمة من {{total}}. تعذر إنشاء «{{title}}». حاول مرة أخرى.",
  partialCreatedBody_few: "تم إنشاء {{count}} مهام من {{total}}. تعذر إنشاء «{{title}}». حاول مرة أخرى.",
  partialCreatedBody_two: "تم إنشاء مهمتين من {{total}}. تعذر إنشاء «{{title}}». حاول مرة أخرى.",
  partialCreatedBody_one: "تم إنشاء مهمة واحدة من {{total}}. تعذر إنشاء «{{title}}». حاول مرة أخرى.",
  partialCreatedBody_zero: "لم يتم إنشاء أي مهمة من {{total}}. تعذر إنشاء «{{title}}». حاول مرة أخرى.",
  linkFailed_other: "تم إنشاء {{count}} مهمة، لكن تعذرت إضافتها إلى الطلب. حاول مرة أخرى.",
  linkFailed_many: "تم إنشاء {{count}} مهمة، لكن تعذرت إضافتها إلى الطلب. حاول مرة أخرى.",
  linkFailed_few: "تم إنشاء {{count}} مهام، لكن تعذرت إضافتها إلى الطلب. حاول مرة أخرى.",
  linkFailed_two: "تم إنشاء مهمتين، لكن تعذرت إضافتهما إلى الطلب. حاول مرة أخرى.",
  linkFailed_one: "تم إنشاء المهمة، لكن تعذرت إضافتها إلى الطلب. حاول مرة أخرى.",
  linkFailed_zero: "لا مهام لإضافتها إلى الطلب.",
  missingInspectionBody: "ارجع وافتح الفحص مرة أخرى.",
  partialCreatedTitle: "لم يتم إنشاء بعض المهام",
suggestedJobA11y: "أمر العمل المقترح {{title}}",
findingsCount_one: "{{count}} نتيجة",
findingsCount_other: "{{count}} نتيجة",
missingTitleOrCategory: "مفقود: العنوان أو الفئة",
editSuggestedJobTitle: "تحرير أمر العمل المقترح",
titlePlaceholderRepairPipe: "على سبيل المثال. إصلاح تسرب الأنابيب",
scopeOfWorkPlaceholder: "نطاق العمل",
whereJobCarriedOutPlaceholder: "أين سيتم تنفيذ أمر العمل هذا؟",
assignToRecommendedA11y: "قم بتعيين {{name}}",
suggestedAssigneeLabel: "المقترح: {{name}} · {{rationale}}",
workPathLabel: "مسار العمل",
missingInspection: "الفحص مفقود",
loadingEllipsis: "جارٍ التحميل…",
accessRestrictedTitle: "الوصول مقيد",
accessRestrictedBody: "يمكن فقط لمنشئ الفحص أو أحد أعضاء فريق الأصل إنشاء أوامر عمل من هذه العناصر الفاشلة.",
accessDeniedAlertTitle: "تم رفض الوصول",
accessDeniedAlertBody: "يمكن فقط لمنشئ الفحص أو فريق الأصول إنشاء أوامر العمل هذه.",
selectSuggestedJobsTitle: "حدد أوامر العمل المقترحة",
selectSuggestedJobsBody: "حدد اقتراحًا واحدًا على الأقل لإنشائه.",
missingDetailsBodySuggest: "بعض الاقتراحات المحددة تفتقد العنوان أو الفئة. قم بتحرير تلك البطاقات قبل إنشاء أوامر العمل.",
jobsAlreadyCreated: "تم بالفعل إنشاء أوامر العمل",
noSuggestedJobs: "لا توجد أوامر عمل مقترحة",
allFindingsLinkedBody: "كل نتيجة فاشلة أو عليها علامة إصلاح في هذا الفحص لديها بالفعل أمر عمل مرتبط.",
noFailedItemsBody: "لا يحتوي هذا الفحص حاليًا على عناصر فاشلة أو عليها علامات إصلاح وتحتاج إلى أمر عمل للمتابعة.",
openReport: "فتح التقرير",
linkedJobsTitle: "أوامر العمل المرتبطة",
linkedJobsHintCannotRecreate: "ارتبطت هذه النتائج بالفعل بأوامر عمل ولا يمكن إنشاؤها مرة أخرى ما لم يُحذف أمر العمل.",
assetFallback: "أصل",
suggestionsCountPill_zero: "{{count}} اقتراح",
suggestionsCountPill_one: "اقتراح واحد",
suggestionsCountPill_two: "اقتراحان",
suggestionsCountPill_few: "{{count}} اقتراحات",
suggestionsCountPill_many: "{{count}} اقتراحًا",
suggestionsCountPill_other: "{{count}} اقتراح",
fromFailedItemsPill_zero: "من {{count}} عنصر فاشل",
fromFailedItemsPill_one: "من عنصر واحد فاشل",
fromFailedItemsPill_two: "من عنصرين فاشلين",
fromFailedItemsPill_few: "من {{count}} عناصر فاشلة",
fromFailedItemsPill_many: "من {{count}} عنصرًا فاشلًا",
fromFailedItemsPill_other: "من {{count}} عنصر فاشل",
alreadyCreatedTitle: "تم إنشاؤه بالفعل",
linkedFindingsHint_one: "نتيجة واحدة لديها أوامر عمل مرتبطة بالفعل ولن تُقترح مرة أخرى.",
linkedFindingsHint_other: "{{count}} نتيجة لديها أوامر عمل مرتبطة بالفعل ولن تُقترح مرة أخرى.",
followUpJobsFromMarkedItems: "مهام من البنود الفاشلة",
aiDraftedHint: "مسودة بالذكاء الاصطناعي. ألغِ تحديد ما لا ينبغي أن يصبح عملاً.",
ruleBasedHint: "ألغِ تحديد ما لا ينبغي أن يصبح عملاً.",
progressLinkNeedsAttention: "لم تتم الإضافة إلى الطلب",
progressLinkMessage: "تم إنشاء أمر العمل، ولكن لم يتم تحديث تقدم الطلب/التقرير المشترك. {{message}}",
retryLink: "إعادة المحاولة",
stillNotLinkedTitle: "لا يزال غير مرتبط",
jobCreatedNotLinkedFallback: "تم إنشاء أمر العمل ولكن تعذر ربطه بسجل التقدم المشترك.",
unableToLinkJobFallback: "تعذر ربط أمر العمل بالطلب.",
missingDetailsBanner_one: "يحتاج اقتراح محدد واحد إلى عنوان أو فئة قبل إنشاء أوامر العمل. المهارات موصى بها لكنها اختيارية لأوامر العمل المقترحة.",
missingDetailsBanner_other: "يحتاج {{count}} اقتراح محدد إلى عنوان أو فئة قبل إنشاء أوامر العمل. المهارات موصى بها لكنها اختيارية لأوامر العمل المقترحة.",
createJobsA11y_zero: "إنشاء {{count}} أمر عمل مقترح",
createJobsA11y_one: "إنشاء أمر عمل مقترح واحد",
createJobsA11y_two: "إنشاء أمرَي عمل مقترحَين",
createJobsA11y_few: "إنشاء {{count}} أوامر عمل مقترحة",
createJobsA11y_many: "إنشاء {{count}} أمرَ عمل مقترحًا",
createJobsA11y_other: "إنشاء {{count}} أمر عمل مقترح",
creatingEllipsisEn: "جارٍ الإنشاء...",
createJobsButton_one: "إنشاء أمر عمل واحد",
aiDraft: {
  button: "صياغة بالذكاء الاصطناعي",
  again: "إعادة الصياغة بالذكاء الاصطناعي",
  notEnough: "رصيد الذكاء الاصطناعي غير كافٍ",
  failedTitle: "لم تنجح الصياغة بالذكاء الاصطناعي",
  failedBody: "قائمتك لم تتغير. يُرجى المحاولة مرة أخرى.",
},
createAndAssignButton_one: "إنشاء أمر عمل واحد وتعيينه",
createAndAssignButton_other: "إنشاء {{count}} أمر عمل وتعيينها",
createAndAssignButton_zero: "لا أوامر عمل لإنشائها",
createAndAssignButton_two: "إنشاء أمري عمل وتعيينهما",
createAndAssignButton_few: "إنشاء {{count}} أوامر عمل وتعيينها",
createAndAssignButton_many: "إنشاء {{count}} أمر عمل وتعيينها",
approvedBy: "وافق عليه {{name}}",
handOverIncompleteTitle: "تم الإنشاء، ولم يُسلَّم الكل",
handOverIncompleteBody: "أوامر العمل موجودة، لكن هذه لم تُسلَّم أو لم يُبلَّغ المقاول: {{names}}. افتح كل أمر لإكماله.",
createJobsButton_other: "إنشاء {{count}} أمر عمل",
findingsCount_zero: "لا نتائج",
findingsCount_two: "نتيجتان",
findingsCount_few: "{{count}} نتائج",
findingsCount_many: "{{count}} نتيجةً",
linkedFindingsHint_zero: "لا نتائج لديها أوامر عمل مرتبطة.",
linkedFindingsHint_two: "نتيجتان لديهما أوامر عمل مرتبطة بالفعل ولن تُقترحا مرة أخرى.",
linkedFindingsHint_few: "{{count}} نتائج لديها أوامر عمل مرتبطة بالفعل ولن تُقترح مرة أخرى.",
linkedFindingsHint_many: "{{count}} نتيجة لديها أوامر عمل مرتبطة بالفعل ولن تُقترح مرة أخرى.",
missingDetailsBanner_zero: "لا اقتراحات محددة تحتاج إلى عنوان أو فئة.",
missingDetailsBanner_two: "يحتاج اقتراحان محددان إلى عنوان أو فئة قبل إنشاء أوامر العمل. المهارات موصى بها لكنها اختيارية لأوامر العمل المقترحة.",
missingDetailsBanner_few: "تحتاج {{count}} اقتراحات محددة إلى عنوان أو فئة قبل إنشاء أوامر العمل. المهارات موصى بها لكنها اختيارية لأوامر العمل المقترحة.",
missingDetailsBanner_many: "يحتاج {{count}} اقتراحًا محددًا إلى عنوان أو فئة قبل إنشاء أوامر العمل. المهارات موصى بها لكنها اختيارية لأوامر العمل المقترحة.",
createJobsButton_zero: "لا أوامر عمل لإنشائها",
createJobsButton_two: "إنشاء أمري عمل",
createJobsButton_few: "إنشاء {{count}} أوامر عمل",
createJobsButton_many: "إنشاء {{count}} أمر عمل",
},
shareScreen: {
  askApproveSuggested_other: "اطلب أيضًا الموافقة على {{count}} إصلاح مقترح",
  askApproveSuggested_many: "اطلب أيضًا الموافقة على {{count}} إصلاحًا مقترحًا",
  askApproveSuggested_few: "اطلب أيضًا الموافقة على {{count}} إصلاحات مقترحة",
  askApproveSuggested_two: "اطلب أيضًا الموافقة على إصلاحين مقترحين",
  askApproveSuggested_one: "اطلب أيضًا الموافقة على إصلاح مقترح واحد",
  askApproveSuggested_zero: "لا إصلاحات مقترحة",
  askApproveSuggestedHint: "يمكنه الموافقة على كل منها أو رفضه.",
  relationshipChangeA11y: "تغيير صلته بالأصل",
  relationshipChange: "تغيير",
  relationship: "صلته: {{role}}",
  greetingTemplateRepairs: "مرحبًا،\n\nإليك تقرير الفحص الخاص بـ {{assetName}}. افتح الرابط لقراءته واضغط رفض على أي إصلاح مقترح لا تريده. ثم وقّع للاعتماد، أو اضغط إرجاع لطلب تعديلات.\n\nشكرًا لك.",
greetingTemplate: "مرحبًا،\n\nإليك تقرير الفحص الخاص بـ {{assetName}}. افتح الرابط لقراءته، ثم وقّع للاعتماد، أو اضغط إرجاع لطلب تعديلات.\n\nشكرًا لك.",
assetFallback: "أصلك",
emailNotSent: "مشترك، ولكن لم يتم إرسال البريد الإلكتروني. انسخ الرابط لترسله بنفسك.",
copyLink: "انسخ الرابط",
shareCreatedTitle: "تم إنشاء المشاركة",
shareThisLinkBody: "شارك هذا الرابط:\n{{link}}",
inspectionNotFound: "لم يتم العثور على الفحص.",
contactNeedsEmail: "أضف بريده الإلكتروني لإرسال التقرير عبر البريد.",
checkEmailAddress: "تحقق من عنوان البريد الإلكتروني: لا يبدو عنوانًا صالحًا.",
checkPhoneNumber: "التحقق من رقم الهاتف: أدخل رقمًا صالحًا للبلد المحدد، أو اتركه فارغًا.",
reportResentNotify: "تم إرسال التقرير مرة أخرى. سيصلك إشعار عند الرد.",
reportSharedNotify: "تم إرسال التقرير. سيصله بريد إلكتروني برابط، وسيصلك إشعار عند الرد.",
createShareFailedFallback: "فشل في إنشاء المشاركة.",
errorTitle: "خطأ",
requiredTitle: "مطلوب",
enterEmailRequired: "يرجى إدخال عنوان البريد الإلكتروني (أو تحديد جهة اتصال لها بريد إلكتروني).",
recipientFallback: "المستلم",
contactFallback: "جهة اتصال",
selectContactTitle: "حدد جهة اتصال",
selectContactBody: "تعتمد المشاركة على جهات الاتصال. الرجاء الضغط على \"تحديد جهة اتصال\" واختيار أو إضافة جهة اتصال للمشاركة معها.",
respondByLine: "الرجاء الرد قبل {{date}}\n\n",
estimatedTotalLine: "الإجمالي المقدر: {{amount}}\n\n",
reviewLinkLine: "رابط المراجعة: {{link}}",
assetFallbackShort: "أصل",
emailSubject: "تقرير الفحص – {{assetName}}",
resentTitle: "أُعيد الإرسال",
sentTitle: "تم الإرسال",
resentBody: "أُعيد إرسال تقرير الفحص إلى المستلم.",
sentBody: "تمت مشاركة تقرير الفحص. سيتم إخطار المستلم.",
deliveryUnconfirmed: "تم إنشاء المشاركة، لكن تعذّر تأكيد التسليم. شارك هذا الرابط يدويًا:\n{{link}}",
inspectionNotFoundPlain: "الفحص غير موجود",
onlyCreatorAssigneeOrTeamCanShare: "يمكن فقط لمنشئ هذا الفحص أو المفتش المعين له أو أحد أعضاء فريق الأصل مشاركة التقرير.",
shareLinkNotConfiguredProd: "لم يُعَدّ رابط ويب قابل للمشاركة لمساحة العمل هذه بعد، لذا قد لا يتمكن المستلمون من فتح رابط التقرير. يرجى التواصل مع المسؤول لديك.",
reviewAssistantTitle: "مساعد المراجعة",
sending: "جارٍ الإرسال…",
resendReportTo: "إعادة إرسال التقرير إلى {{name}}",
sendReportTo: "أرسل التقرير إلى {{name}}",
theRequesterFallback: "مقدّم الطلب",
oneTapHint: "مُعبّأ من الطلب. غيّر الشخص أو الرسالة أدناه إذا لزم الأمر.",
shareTo: "إرسال إلى",
contactsHint: "اضغط حدد جهة الاتصال واختر الشخص. يظهر في الأعلى من أرسلته إليهم من قبل.",
whoCanOpen: "لا يمكن فتح التقرير إلا لهذا الشخص. الرابط في بريده يسجّل دخوله مباشرة. أي شخص آخر يصله الرابط يمكنه فقط أن يطلب منك الوصول.",
changeContact: "تغيير جهة الاتصال",
selectContact: "حدد جهة الاتصال",
primaryChooseRole: "اختر الدور",
primaryAddEmail: "أضف البريد الإلكتروني",
primaryResend: "إرسال مرة أخرى",
primarySend: "إرسال التقرير",
noEmailOrPhone: "لا يوجد بريد إلكتروني أو هاتف",
shareToContactTitle: "إرسال إلى",
howToSend: "كيفية الإرسال",
byEmail: "عبر البريد الإلكتروني",
roleLabel: "الدور *",
recipientNameOptional: "الاسم (اختياري)",
recipientNamePlaceholder: "على سبيل المثال. جون سميث",
recipientEmailLabel: "البريد الإلكتروني *",
recipientEmailA11y: "البريد الإلكتروني (مطلوب)",
recipientEmailPlaceholder: "client@example.com",
phoneOptional: "الهاتف (اختياري)",
shareStatus: "أُرسل من قبل",
firstSharedLabel: "أُرسل في {{date}}",
lastResharedLabel: "أُعيد إرساله في {{date}}",
noResponseByDeadline: "لا رد حتى التاريخ المحدد. اضغط إرسال مرة أخرى للتذكير.",
responseDeadlineOptional: "الرد قبل (اختياري)",
messageOptional: "الرسالة (اختياري)",
messagePlaceholder: "إضافة ملاحظة للمستلم...",
includeSuggestedJobsTitle: "قم بتضمين أوامر العمل المقترحة في المراجعة المشتركة",
includeSuggestedJobsHint_one: "يضيف عنصر متابعة مقترحًا واحدًا لموافقة المستلم.",
includeSuggestedJobsHint_other: "يضيف {{count}} عنصر متابعة مقترح لموافقة المستلم.",
missingEstimateWarning_one: "عنصر واحد بلا تقدير تكلفة — سيظل موجودًا في التقرير، لكن بدون تكلفة. يمكنك المشاركة الآن أو إضافة التقديرات أولاً.",
missingEstimateWarning_other: "{{count}} عنصر بلا تقدير تكلفة — ستظل موجودة في التقرير، لكن بدون تكلفة. يمكنك المشاركة الآن أو إضافة التقديرات أولاً.",
couldNotShareReportTitle: "تعذرت مشاركة التقرير",
sharingFailedFallback: "تعذرت المشاركة. تحقق من اتصالك وحاول مرة أخرى.",
includeSuggestedJobsHint_zero: "لا توجد عناصر متابعة مقترحة لإضافتها لموافقة المستلم.",
includeSuggestedJobsHint_two: "يضيف عنصرَي متابعة مقترحين لموافقة المستلم.",
includeSuggestedJobsHint_few: "يضيف {{count}} عناصر متابعة مقترحة لموافقة المستلم.",
includeSuggestedJobsHint_many: "يضيف {{count}} عنصر متابعة مقترحًا لموافقة المستلم.",
missingEstimateWarning_zero: "لا عناصر بلا تقدير تكلفة.",
missingEstimateWarning_two: "عنصران بلا تقدير تكلفة — سيظلان موجودين في التقرير، لكن بدون تكلفة. يمكنك المشاركة الآن أو إضافة التقديرات أولاً.",
missingEstimateWarning_few: "{{count}} عناصر بلا تقدير تكلفة — ستظل موجودة في التقرير، لكن بدون تكلفة. يمكنك المشاركة الآن أو إضافة التقديرات أولاً.",
missingEstimateWarning_many: "{{count}} عنصرًا بلا تقدير تكلفة — ستظل موجودة في التقرير، لكن بدون تكلفة. يمكنك المشاركة الآن أو إضافة التقديرات أولاً.",
},
reportScreen: {
  exportFailed: {
    word: "تعذر إنشاء ملف Word. حاول مرة أخرى.",
    excel: "تعذر إنشاء ملف Excel. حاول مرة أخرى.",
    pdf: "تعذر إنشاء ملف PDF. حاول مرة أخرى.",
  },
  exportPreparing: {
    word: "جارٍ تجهيز ملف Word…",
    excel: "جارٍ تجهيز ملف Excel…",
    pdf: "جارٍ تجهيز ملف PDF…",
  },
editRepairDetailsTitle: "تحرير تفاصيل الإصلاح",
saveFailedFallback: "فشل الحفظ.",
titleLabel: "العنوان",
titlePlaceholder: "مثال: إصلاح تسرب الصنبور",
categoryLabel: "الفئة",
descriptionLabel: "الوصف",
descriptionPlaceholder: "ما الذي يجب فعله...",
priorityLabel: "الأولوية",
dueDateOptional: "تاريخ الاستحقاق (اختياري)",
estimatedCostOptional: "التكلفة المقدرة (اختياري)",
estimatedCostA11y: "مبلغ التكلفة المقدرة",
visibilityLabel: "الظهور",
saveRepairFailedTitle: "تعذر حفظ الإصلاح",
syncFailedGeneric: "فشلت المزامنة.",
skipped: "تم تخطيه",
downloadPdf: "تنزيل PDF",
downloadExcel: "تنزيل Excel",
downloadWord: "تنزيل Word",
sharePdfToGoogleDrive: "مشاركة PDF على Google Drive...",
shareExcelToOneDrive: "مشاركة Excel في OneDrive...",
shareWordToSharePoint: "مشاركة Word في SharePoint...",
googleDrive: "Google Drive",
oneDrive: "OneDrive",
sharePoint: "SharePoint",
shareRequiredTitle: "شارك التقرير أولًا",
shareRequiredBody: "اضغط مشاركة واختر لمن هو. ينشئ ذلك الرابط الذي يفتحه لقراءته والرد عليه.",
hostedLinkCopiedTitle: "تم نسخ رابط المراجعة",
inspectionReportFileLabel: "تقرير الفحص ({{format}})",
exportFileError: "تعذر إنشاء ملف التصدير.",
exportReadyTitle: "التصدير جاهز",
exportReadyBody: "لقد بدأ تنزيل ملفك.",
reportInsightTitle: "رؤى التقرير",
reviewRepairEvidenceAction: "قم بمراجعة أدلة الإصلاح والتكلفة المقدرة قبل التصدير.",
shareReportAction: "اضغط مشاركة لإرسال رابط يفتح التقرير لقراءته والرد عليه.",
runFirstExportAction: "اضغط تنزيل لحفظ نسخة PDF أو Excel أو Word بشعارك.",
itemsVisible_one: "عنصر فحص واحد مرئي في التقرير.",
itemsVisible_other: "{{count}} عنصر فحص مرئي في التقرير.",
repairFindingsIncluded_one: "تتضمن نتيجة إصلاح واحدة.",
repairFindingsIncluded_other: "تتضمن {{count}} نتيجة إصلاح.",
noRepairFindingsIncluded: "لم يتم تضمين نتائج الإصلاح.",
hostedLinkAvailable: "رابط المراجعة جاهز للإرسال.",
hostedLinkNotAvailable: "لا يوجد رابط مراجعة بعد. اضغط مشاركة لإنشائه.",
exportRecords_one: "يوجد سجل تصدير حديث واحد.",
exportRecords_other: "يوجد {{count}} سجل تصدير حديث.",
noExportActivity: "لم ينزّل أحد هذا التقرير بعد.",
metricInspected: "تم الفحص",
metricRepairs: "الإصلاحات",
metricExports: "عمليات التصدير",
metricSummary: "ملخص",
summaryReady: "جاهز",
summaryMissing: "مفقود",
insightSourceLabel: "عناصر هذا الفحص وإصلاحاته",
nextSteps: "الخطوات التالية",
copyHostedReportLink: "نسخ رابط المراجعة",
brandingSettings: "إعدادات الهوية",
moreReportOptionsA11y: "المزيد من خيارات التقرير",
yourSignOff: "اعتمادك",
signOff: "اعتماد",
reviewAndSignOff: "الموافقة أو الإرجاع",
shareA11y: "مشاركة",
share: "مشاركة",
assignedTo: "مُسنَد إلى {{name}}",
unassigned: "غير مُكلَّف",
quoteAwarded: "تم ترسية عرض السعر",
quoteRequested: "طُلب عرض سعر",
quotes: "عروض الأسعار",
jobsCreated_one: "تم إنشاء أمر عمل واحد",
jobsCreated_other: "تم إنشاء {{count}} أمر عمل",
findingsMayNeedJobs_one: "نتيجة واحدة قد تحتاج إلى أوامر عمل",
findingsMayNeedJobs_other: "{{count}} نتيجة قد تحتاج إلى أوامر عمل",
noRepairFindingsInReport: "لا توجد نتائج إصلاح في هذا التقرير",
createJobsFromFindingsA11y: "تأكيد المهام من النتائج",
createJobsFromFindings: "تأكيد المهام",
openLinkedJobsA11y: "فتح أوامر العمل المرتبطة",
openLinkedJobs_one: "فتح أمر العمل المرتبط",
openLinkedJobs_other: "فتح أوامر العمل المرتبطة",
approved: "معتمد",
awaitingApproval: "بانتظار الاعتماد",
approvedBy: "اعتمده {{name}}",
recipientFallback: "المستلم",
approvedOnAt: " في {{date}} الساعة {{time}}",
reviewRequested: "طُلبت المراجعة",
sharedWithName: "تمت المشاركة مع {{name}}",
reviewRequestedFallback: "طُلبت المراجعة",
firstShared: "أول مشاركة {{date}}",
lastReshared: " | آخر إعادة مشاركة {{date}}",
resendAndUpdateDeadline: "إعادة الإرسال وتحديث الموعد",
noReviewRequestedYet: "لم يتم طلب أي مراجعة بعد.",
notSharedYetPrefix: "لم تتم مشاركته بعد — استخدم ",
shareAboveLink: "شارك أعلاه",
notSharedYetSuffix: " لطلب المراجعة.",
theInspectorFallback: "المفتش",
askInspectorEmptyHint: "اسأل المفتش عن هذا التقرير. لا توجد رسائل حتى الآن.",
discussInspectionEmptyHint: "ناقش هذا الفحص مع المراجع. لا توجد رسائل حتى الآن.",
atAGlance: "في لمحة",
estTotal: "الإجمالي التقديري",
approvalLabel: "الاعتماد",
approvalAwaiting: "بالانتظار",
jobsLabel: "المهام",
recentExports: "عمليات التصدير الأخيرة",
loadingExportHistory: "جارٍ تحميل سجل التصدير...",
noExportsRecorded: "لم يتم تسجيل أي عمليات تصدير لهذا التقرير حتى الآن.",
loadErrorTitle: "تعذر تحميل هذا التقرير",
goBack: "رجوع",
reportAvailableWhenCompleted: "يتوفر التقرير عند اكتمال الفحص.",
findingsAndEvidence: "النتائج والأدلة",
noItemsRecorded: "لم تُسجَّل أي عناصر فحص لهذا الفحص.",
otherGroup: "أخرى",
inspectorNotes: "ملاحظات المفتش",
noteLabel: "الملاحظة",
itemSkippedFallback: "تم تخطي هذا العنصر أثناء الفحص.",
mediaCount: "الوسائط · {{count}}",
playVideo: "تشغيل الفيديو {{index}}",
repairAndRemediation: "الإصلاح والمعالجة",
descriptionOrRecommendation: "الوصف",
recommendation: "توصية",
labourAndMaterials: "العمالة والمواد",
urgentFallback: "عاجل",
requiredSkills: "المهارات المطلوبة",
dueDate: "تاريخ الاستحقاق",
estimatedCost: "التكلفة المقدرة",
urgentRepairNote: "ملاحظة إصلاح عاجلة",
urgentRepairNoteFallback: "تم وضع علامة على هذا العنصر على أنه يتطلب اهتمامًا عاجلاً.",
jobCreated: "تم إنشاء المهمة",
jobsCreatedPlain: "المهام المُنشأة",
editRepairDetails: "تحرير تفاصيل الإصلاح",
whereThisStands: "أين وصل هذا",
reportOptionsTitle: "خيارات التقرير",
couldNotLoadImageSubtext: "ربما تم نقل الصورة أو أنها غير متوفرة.",
syncReportWorkspaceFailedTitle: "تعذر إنشاء الملف",
statusPrefix: "الحالة: {{status}}",
templateVersionLabel: "قائمة التحقق: {{name}}{{version}}",
conductedInspection: "تم إجراء الفحص",
inspectorFallback: "المفتش",
itemsVisible_zero: "لا توجد عناصر فحص مرئية في التقرير.",
itemsVisible_two: "عنصرا فحص مرئيان في التقرير.",
itemsVisible_few: "{{count}} عناصر فحص مرئية في التقرير.",
itemsVisible_many: "{{count}} عنصر فحص مرئيًا في التقرير.",
repairFindingsIncluded_zero: "لا تتضمن أي نتيجة إصلاح.",
repairFindingsIncluded_two: "تتضمن نتيجتي إصلاح.",
repairFindingsIncluded_few: "تتضمن {{count}} نتائج إصلاح.",
repairFindingsIncluded_many: "تتضمن {{count}} نتيجة إصلاح.",
exportRecords_zero: "لا توجد سجلات تصدير حديثة.",
exportRecords_two: "يوجد سجلا تصدير حديثان.",
exportRecords_few: "توجد {{count}} سجلات تصدير حديثة.",
exportRecords_many: "يوجد {{count}} سجل تصدير حديثًا.",
jobsCreated_zero: "لم يتم إنشاء أي أمر عمل",
jobsCreated_two: "تم إنشاء أمرَي عمل",
jobsCreated_few: "تم إنشاء {{count}} أوامر عمل",
jobsCreated_many: "تم إنشاء {{count}} أمر عمل",
findingsMayNeedJobs_zero: "لا نتائج قد تحتاج إلى أوامر عمل",
findingsMayNeedJobs_two: "نتيجتان قد تحتاجان إلى أوامر عمل",
findingsMayNeedJobs_few: "{{count}} نتائج قد تحتاج إلى أوامر عمل",
findingsMayNeedJobs_many: "{{count}} نتيجة قد تحتاج إلى أوامر عمل",
openLinkedJobs_zero: "لا أوامر عمل مرتبطة",
openLinkedJobs_two: "فتح أمري العمل المرتبطين",
openLinkedJobs_few: "فتح أوامر العمل المرتبطة",
openLinkedJobs_many: "فتح أوامر العمل المرتبطة",
},
convertScreen: {
  missingShareBody: "افتح هذا من تقرير الفحص لتحويل الإصلاحات المعتمدة إلى مهام.",
  missingShareTitle: "لا يوجد شيء لفتحه هنا",
editA11y: "تحرير {{title}}",
dueLabel: "يحل في {{date}}",
missingFieldsHint: "مفقود: العنوان أو الفئة أو المهارات المطلوبة",
editJobDetailsTitle: "تحرير تفاصيل أمر العمل",
requiredTitle: "مطلوب",
requiredBody: "العنوان والفئة مطلوبان.",
titleLabel: "العنوان",
titlePlaceholder: "مثال: إصلاح تسرب الصنبور",
categoryLabel: "الفئة *",
priorityLabel: "الأولوية (اختياري)",
dueDateLabel: "تاريخ الاستحقاق (اختياري)",
jobLocationLabel: "موقع أمر العمل (اختياري)",
addressSearchPlaceholder: "البحث عن عنوان…",
estimateLabel: "التقدير (اختياري)",
costPlaceholder: "0.00",
assigneeLabel: "المكلَّف (اختياري)",
noneOption: "بلا",
saving: "جارٍ الحفظ…",
save: "حفظ",
missingShare: "المشاركة مفقودة",
loading: "جارٍ التحميل...",
noApprovedRepairsTitle: "لا توجد إصلاحات معتمدة",
noApprovedRepairsBody: "لم يوافق العميل على أي إصلاحات لهذه المشاركة حتى الآن.",
onlyCreatorOrTeamCanConvert: "يمكن فقط لمنشئ الفحص أو أحد أعضاء فريق الأصل إنشاء أوامر عمل من هذه المشاركة.",
unsavedJobEditsMessage: "لديك تعديلات غير محفوظة على أمر العمل. هل تريد المغادرة وفقدانها؟",
leave: "مغادرة",
keepEditing: "استمر في التحرير",
createJobsErrorTitle: "تعذر إنشاء المهام",
createJobsErrorFallback: "فشل في إنشاء أوامر العمل.",
selectRepairsTitle: "حدد الإصلاحات",
selectRepairsBody: "حدد إصلاحًا معتمدًا واحدًا على الأقل (ضع علامة في المربع الموجود على كل بطاقة). اضغط على البطاقة لتعديل العنوان أو الفئة أو المكلف قبل الإنشاء.",
missingDetailsTitle: "تفاصيل مفقودة",
missingDetailsBody: "بعض الإصلاحات المحددة تفتقد العنوان أو الفئة أو المهارات المطلوبة. اضغط على كل بطاقة لتحريرها قبل إنشاء أوامر العمل.",
step1WorkPath: "من سيقوم بالعمل؟",
step1WorkPathHint: "اختر فريقك أو مقاولًا واحدًا أو اطلب عروض أسعار. ستختار الأشخاص بعد إنشاء المهام.",
step2SelectItems: "ما الإصلاحات التي تحتاج إلى مهمة؟",
creatingJobs: "جارٍ الإنشاء…",
createJobs_one: "إنشاء أمر عمل واحد",
createJobs_other: "إنشاء {{count}} أمر عمل",
createJobs_zero: "لا أوامر عمل لإنشائها",
createJobs_two: "إنشاء أمري عمل",
createJobs_few: "إنشاء {{count}} أوامر عمل",
createJobs_many: "إنشاء {{count}} أمر عمل",
},
completeScreen: {
  approvedToast: "تم اعتماد الفحص. شارك التقرير أو اختر تم.",
  alerts: {
    optionalBody_other: "{{count}} بند اختياري بلا إجابة أو تخطٍ. هل تريد الإكمال على أي حال؟",
    optionalBody_many: "{{count}} بندًا اختياريًا بلا إجابة أو تخطٍ. هل تريد الإكمال على أي حال؟",
    optionalBody_few: "{{count}} بنود اختيارية بلا إجابة أو تخطٍ. هل تريد الإكمال على أي حال؟",
    optionalBody_two: "بندان اختياريان بلا إجابة أو تخطٍ. هل تريد الإكمال على أي حال؟",
    optionalBody_one: "بند اختياري واحد بلا إجابة أو تخطٍ. هل تريد الإكمال على أي حال؟",
    optionalBody_zero: "لا توجد بنود اختيارية بلا إجابة. هل تريد الإكمال؟",
    failedTitle_other: "{{count}} بند فاشل بلا صورة أو ملاحظة",
    failedTitle_many: "{{count}} بندًا فاشلًا بلا صورة أو ملاحظة",
    failedTitle_few: "{{count}} بنود فاشلة بلا صورة أو ملاحظة",
    failedTitle_two: "بندان فاشلان بلا صورة أو ملاحظة",
    failedTitle_one: "بند فاشل واحد بلا صورة أو ملاحظة",
    failedTitle_zero: "لا توجد بنود فاشلة بلا صورة أو ملاحظة",
    requiredBody_other: "أجب عن {{count}} بند مطلوب أو تخطَّها قبل إكمال هذا الفحص.",
    requiredBody_many: "أجب عن {{count}} بندًا مطلوبًا أو تخطَّها قبل إكمال هذا الفحص.",
    requiredBody_few: "أجب عن {{count}} بنود مطلوبة أو تخطَّها قبل إكمال هذا الفحص.",
    requiredBody_two: "أجب عن بندين مطلوبين أو تخطَّهما قبل إكمال هذا الفحص.",
    requiredBody_one: "أجب عن بند مطلوب واحد أو تخطَّه قبل إكمال هذا الفحص.",
    requiredBody_zero: "لا توجد بنود مطلوبة متبقية.",
    completedToast: "اكتمل الفحص",
    optionalTitle: "بنود بلا إجابة",
    goToFailed: "الانتقال إلى البند الفاشل",
    failedBody: "أضف صورة أو ملاحظة ليرى الآخرون المشكلة، أو أكمله كما هو.",
    jumpToFirst: "الانتقال إلى الأول",
    requiredTitle: "بنود مطلوبة غير مكتملة",
    tryAgain: "إعادة المحاولة",
    savingBody: "إنها محفوظة على هذا الجهاز. اضغط إعادة المحاولة، ثم أكمل الفحص.",
    savingTitle: "لم تُحفظ بعض الإجابات بعد",
    conflictChoose: "اختيار",
    conflictBody: "اختر الاحتفاظ بإجاباتي أو استخدام إجاباتهم، ثم أكمله.",
    conflictTitle: "قام شخص آخر بتغيير هذا الفحص",
  },
  status: {
    nextVisit: "الزيارة التالية مستحقة في {{date}}.",
    requesterWaiting: "مقدم الطلب ينتظر هذا التقرير.",
    sentTo: "أُرسل إلى {{name}} للموافقة.",
    approveSelf: "راجع النتائج، ثم اضغط اعتماد.",
    approveOrLeave: "اعتمده بنفسك أو اتركه لـ {{name}}.",
  },
  actions: {
    approve: "اعتماد",
    createCertificate: "إصدار الشهادة المجددة",
    shareRequester: "مشاركة التقرير مع مقدم الطلب",
    createApprovedJobs: "إنشاء المهام المعتمدة",
    scheduleNext: "جدولة الفحص التالي",
    shareReport: "مشاركة التقرير",
    exportReport: "تصدير التقرير",
    report: "التقرير",
    done: "تم",
    confirmJobs: "تأكيد المهام",
  },
loadErrorTitle: "تعذر تحميل هذا الفحص",
loadErrorDescription: "تحقق من اتصالك وحاول مرة أخرى.",
notFoundTitle: "الفحص غير موجود",
notFoundDescription: "ربما تمت إزالة هذا الفحص، أو أن الرابط قديم.",
goBack: "رجوع",
notCompletedYet: "لم ينتهِ هذا الفحص بعد.",
back: "رجوع",
generateSummaryError: "تعذر إنشاء ملخص الفحص. يرجى المحاولة مرة أخرى.",
saveSummaryError: "تعذر حفظ ملخص الفحص. يرجى المحاولة مرة أخرى.",
reopenErrorTitle: "تعذرت إعادة الفتح",
reopenErrorFallback: "حاول مرة أخرى.",
jobFollowUpTitle: "متابعة {{name}}",
jobFollowUpDescription: "متابعة من فحص {{checklist}} على {{assetName}}، {{date}}.",
assetFallback: "أصل",
templateFallback: "تفتيش",
certificateTitle: "شهادة {{name}}",
cannotCreateCertificateTitle: "لا يمكن إنشاء الشهادة",
cannotCreateCertificateBody: "هذا الفحص غير مرتبط بأصل.",
certificateCreatedTitle: "تم إنشاء الشهادة",
certificateCreatedBody: "تم حفظ الشهادة في مستندات الأصل.",
errorTitle: "تعذر إنشاء الشهادة",
certificateCreateError: "تعذر إنشاء الشهادة.",
inspectedLabel: "تم الفحص",
failedItemsLabel: "العناصر الفاشلة",
followUpJobsLabel: "مهام مقترحة",
inspectionAssistantTitle: "مساعد التفتيش",
confirmNextActions: "ما التالي",
moreCompletionActions: "المزيد",
moreCompletionActionsSummary: "إنشاء مهمة يدويًا، أو إعادة فتح الفحص، أو مشاركة التقرير.",
createJobNow: "إنشاء مهمة الآن",
notifyTeam: "إشعار الفريق",
syncFailedTitle: "تعذر حفظ الملخص",
syncFailedFallback: "تعذر الطلب. تحقق من اتصالك وحاول مرة أخرى.",
},
templateCard: {
allAssetTypes: "جميع أنواع الأصول",
categoryGeneral: "عام",
categoriesCount_zero: "{{count}} فئة",
categoriesCount_one: "فئة واحدة",
categoriesCount_two: "فئتان",
categoriesCount_few: "{{count}} فئات",
categoriesCount_many: "{{count}} فئةً",
categoriesCount_other: "{{count}} فئة",
usedCount_zero: "لم يُستخدم بعد",
usedCount_one: "استُخدم مرة واحدة",
usedCount_two: "استُخدم مرتين",
usedCount_few: "استُخدم {{count}} مرات",
usedCount_many: "استُخدم {{count}} مرةً",
usedCount_other: "استُخدم {{count}} مرة",
createdDate: "أُنشئ في {{date}}",
allTeams: "جميع الفرق",
selectedTeams: "الفرق المحددة",
},
checklistCard: {
allTypes: "جميع الأنواع",
shared: "مشترك",
totalItems: "إجمالي العناصر",
required: "مطلوب",
optional: "اختياري",
usedTimes_one: "استُخدم مرة واحدة",
usedTimes_other: "استُخدم {{count}} مرة",
completedCount_zero: "{{count}} مكتمل",
completedCount_one: "{{count}} مكتمل",
completedCount_two: "{{count}} مكتمل",
completedCount_few: "{{count}} مكتمل",
completedCount_many: "{{count}} مكتمل",
completedCount_other: "{{count}} مكتمل",
estMinutes: "~{{count}} دقيقة",
createdDate: "أُنشئ في {{date}}",
usedTimes_zero: "لم يُستخدم بعد",
usedTimes_two: "استُخدم مرتين",
usedTimes_few: "استُخدم {{count}} مرات",
usedTimes_many: "استُخدم {{count}} مرةً",
},
conditionalEditor: {
showOnlyWhen: "الإظهار فقط عندما",
addPreviousItemFirst: "أضف عنصرًا سابقًا أولًا لجعل هذا العنصر مشروطًا.",
parentItem: "العنصر الأب",
untitledItem: "عنصر بلا عنوان",
alwaysShown: "معروض دائمًا",
expectedAnswer: "الإجابة المتوقعة",
notConditional: "غير مشروط",
clearCondition: "مسح الشرط",
onlyShownWhen: "يظهر فقط عندما يكون \"{{parent}}\" هو {{value}}.",
conditionInvalidAfterReorder: "لم يعد الشرط الحالي صالحًا بعد إعادة الترتيب. اختر عنصرًا سابقًا أو امسح الشرط.",
itemAlwaysShown: "يتم عرض هذا العنصر دائمًا.",
},
card: {
awaitingReviewerResponse: "في انتظار رد المراجع",
inspectorFallback: "المفتش",
recipientFallback: "المستلم",
sharePendingCount_zero: "{{count}} معلق",
sharePendingCount_one: "{{count}} معلق",
sharePendingCount_two: "{{count}} معلق",
sharePendingCount_few: "{{count}} معلق",
sharePendingCount_many: "{{count}} معلق",
sharePendingCount_other: "{{count}} معلق",
shareDeclinedCount_zero: "{{count}} مرفوض",
shareDeclinedCount_one: "{{count}} مرفوض",
shareDeclinedCount_two: "{{count}} مرفوض",
shareDeclinedCount_few: "{{count}} مرفوض",
shareDeclinedCount_many: "{{count}} مرفوض",
shareDeclinedCount_other: "{{count}} مرفوض",
shareApprovedCount_zero: "{{count}} معتمد",
shareApprovedCount_one: "{{count}} معتمد",
shareApprovedCount_two: "{{count}} معتمد",
shareApprovedCount_few: "{{count}} معتمد",
shareApprovedCount_many: "{{count}} معتمد",
shareApprovedCount_other: "{{count}} معتمد",
sharedWith: "تمت المشاركة مع {{names}}",
responseDue: "الرد قبل {{date}}",
templateFallback: "تفتيش",
assetFallback: "أصل غير معروف",
inspectorA11y: "المفتش {{name}}",
issuesCountA11y_zero: "{{count}} مشكلة",
issuesCountA11y_one: "مشكلة واحدة",
issuesCountA11y_two: "مشكلتان",
issuesCountA11y_few: "{{count}} مشكلات",
issuesCountA11y_many: "{{count}} مشكلةً",
issuesCountA11y_other: "{{count}} مشكلة",
repairsCountA11y_zero: "{{count}} إصلاح",
repairsCountA11y_one: "إصلاح واحد",
repairsCountA11y_two: "إصلاحان",
repairsCountA11y_few: "{{count}} إصلاحات",
repairsCountA11y_many: "{{count}} إصلاحًا",
repairsCountA11y_other: "{{count}} إصلاح",
urgentCountA11y_zero: "{{count}} عاجل",
urgentCountA11y_one: "{{count}} عاجل",
urgentCountA11y_two: "{{count}} عاجل",
urgentCountA11y_few: "{{count}} عاجل",
urgentCountA11y_many: "{{count}} عاجل",
urgentCountA11y_other: "{{count}} عاجل",
openAssetA11y: "فتح الأصل {{assetName}}",
urgentPill: "عاجل {{count}}",
issuesPill: "المشكلات {{count}}",
repairsPill: "الإصلاحات {{count}}",
awaitingApproval: "بانتظار الموافقة",
sharedDense: "مشترك",
reportShared: "تمت مشاركة التقرير",
},
noteSuggestions: {
suggestions: "اقتراحات",
tapToInsert: "انقر للإدراج",
findingRecentNotes: "جارٍ البحث عن الملاحظات الأخيرة...",
},
/** The runner's item controls, footer and summary line (were English literals). */
runner: {
  skipGroupBody_other: "تحديد {{count}} بند في هذه المجموعة كمتخطى، ثم الانتقال إلى المجموعة التالية؟",
  skipGroupBody_many: "تحديد {{count}} بندًا في هذه المجموعة كمتخطى، ثم الانتقال إلى المجموعة التالية؟",
  skipGroupBody_few: "تحديد {{count}} بنود في هذه المجموعة كمتخطاة، ثم الانتقال إلى المجموعة التالية؟",
  skipGroupBody_two: "تحديد بندين في هذه المجموعة كمتخطيين، ثم الانتقال إلى المجموعة التالية؟",
  skipGroupBody_one: "تحديد بند واحد في هذه المجموعة كمتخطى، ثم الانتقال إلى المجموعة التالية؟",
  skipGroupBody_zero: "لا توجد بنود في هذه المجموعة لتخطيها.",
  syncUnsavedBanner: "لم يُحفظ أحد التغييرات. اضغط للمحاولة مرة أخرى.",
  syncFailedBanner: "لم تُحفظ بعض الإجابات بعد. إنها محفوظة على هذا الجهاز. اضغط للمحاولة مرة أخرى.",
  tryAgain: "يرجى المحاولة مرة أخرى.",
  moveToItemTitle: "تعذر الانتقال إلى هذا البند",
  captureUnsupported: "لا يمكن حفظ هذا النوع من الالتقاط في بند.",
  captureScanBody: "يقرأ الماسح رموز QR ولا تُحفظ في البنود.",
  captureScanTitle: "استخدم الماسح لرموز QR",
  captureMeasurementAdded: "تمت إضافة القياس إلى ملاحظة البند.",
  captureMeasurement: "القياس: {{value}}",
  captureNoteAdded: "تمت إضافة الملاحظة إلى البند.",
  capturePhotoAdded: "تمت إضافة الصورة إلى البند.",
  captureNoNote: "لم يتم التقاط أي ملاحظة.",
  captureNoPhoto: "لم يتم التقاط أي صورة.",
  capturePhotosOff: "هذا البند لا يقبل الصور.",
  captureNoItem: "افتح بندًا أولاً، ثم التقط مرة أخرى.",
  captureMismatch: "هذا الالتقاط يخص فحصًا آخر.",
  captureNotFound: "تعذر العثور على هذا الالتقاط. التقطه مرة أخرى.",
  captureNotSavedTitle: "لم يتم حفظ الالتقاط",
  skipGroupReason: "المجموعة غير منطبقة",
  skipGroupConfirm: "تخطي المجموعة",
  skipGroupTitle: "تخطي هذه المجموعة؟",
  keysClose: "إغلاق هذه اللوحة",
  keysToggle: "إظهار هذه اللوحة أو إخفاؤها",
  keysSkip: "تخطي البند المفتوح",
  keysYesNo: "الإجابة نعم / لا (البند المفتوح)",
  keysRate: "الإجابة ناجح / فاشل / لا ينطبق (البند المفتوح)",
  keysPrevNext: "البند أو المجموعة السابقة / التالية",
  timelineStatusScheduled: "مجدول",
  timelineStatusCreated: "تم الإنشاء",
  timelineAutomatic: "تلقائي",
  timelineUpdated: "آخر تحديث",
  timelineCancelled: "تم إلغاء الفحص",
  timelineApproved: "تمت الموافقة على التقرير",
  timelineCompleted: "اكتمل الفحص",
  timelineResumeScheduled: "تمت جدولة الاستئناف",
  timelinePaused: "تم إيقاف الفحص مؤقتًا",
  timelineStarted: "بدأ الفحص",
  timelineCreated: "تم إنشاء الفحص",
  exportReport: "تصدير التقرير",
  report: "التقرير",
  askAiDescription: "احصل على مساعدة في الفحوصات التالية بناءً على إجاباتك حتى الآن.",
  askAiTooltip: "يمكن للذكاء الاصطناعي المساعدة في الفحوصات التالية",
  askAi: "اسأل الذكاء الاصطناعي",
  saveAndExit: "حفظ وخروج",
  savedFindInWork: "تم الحفظ. تجده في العمل ضمن عملي لمتابعته.",
  delete: "حذف",
  deleteBody: "لا يمكن التراجع عن ذلك.",
  deleteTitle: "حذف هذا الفحص؟",
  allItemsDone: "اكتملت جميع البنود. اضغط إكمال الفحص.",
  sharedReportHint: "إذا شارك أحدهم تقريرًا معك، فافتح الرابط الموجود في رسالته. يمكنك أيضًا مراجعة النشاط لمعرفة التقارير التي تنتظرك.",
  requester: "مقدم الطلب",
  fromRequest: "من طلب",
  unknownStatus: "غير معروف",
  itemsHidden: "لم تعد {{total}} بنود منطبقة، لذا تم إخفاؤها.",
  itemHiddenOne: "لم يعد «{{label}}» منطبقًا، لذا تم إخفاؤه.",
  addNoteFirstBody: "اكتب ملاحظة قصيرة، ثم اضغط تحسين.",
  addNoteFirstTitle: "أضف ملاحظة أولاً",
  signInVideos: "سجّل الدخول لإضافة مقاطع الفيديو.",
  signInPhotos: "سجّل الدخول لإضافة الصور.",
  signInTitle: "يلزم تسجيل الدخول",
  recordVideo: "سجّل فيديو أو اختره",
  takePhoto: "التقط صورة أو اخترها",
  polishFailedTitle: "تعذر تحسين النص",
  polishedTitle: "صياغة محسّنة",
  discard: "تجاهل",
  editDraft: "تعديل",
  accept: "قبول",
  revert: "تراجع",
  draftNoteTitle: "مسودة ملاحظة لـ {{label}}",
  previousInspection: "الفحص السابق",
  previousRating: "السابق: {{rating}}",
  previousNote: "المرة السابقة: {{note}}",
  videoOfA11y: "الفيديو {{index}} من {{total}}",
  photoOfA11y: "الصورة {{index}} من {{total}}",
  expandDetails: "إظهار التفاصيل",
  collapseDetails: "إخفاء التفاصيل",
  collapsed: "مطوي",
  expanded: "موسّع",
  stateNotCompletedShort: "غير مكتمل",
  stateSkippedShort: "تم تخطيه",
  stateCompletedShort: "مكتمل",
  itemHeaderA11y: "{{label}}، {{state}}، {{expanded}}",
  stateNotCompleted: "لم يكتمل",
  stateCompleted: "اكتمل البند",
  stateSkipped: "تم التخطي",
  followUpAddA11y: "إضافة متابعة لـ {{label}}",
  followUpEditA11y: "تعديل متابعة {{label}}",
  flaggedNeedsJob: "عليه تنبيه. هل يحتاج إلى مهمة؟",
  mediaAddA11y: "إضافة صورة أو فيديو لـ {{label}}",
  mediaAttachedA11y: "إضافة دليل لـ {{label}}، {{total}} مرفقة",
  noteAddA11y: "إضافة ملاحظة أو إملاؤها لـ {{label}}",
  noteEditA11y: "تعديل ملاحظة {{label}}",
  note: "ملاحظة",
  naA11y: "غير منطبق",
  naSub: "لا ينطبق هنا",
  na: "لا ينطبق",
  flagSub: "يحتاج إلى نظرة ثانية",
  flag: "تنبيه",
  failSub: "لا يستوفي المعايير",
  fail: "فاشل",
  passSub: "يستوفي معايير الفحص",
  pass: "ناجح",
media: "الوسائط",
followUp: "متابعة",
followUpProposed: "مهمة مقترحة",
yesOrNo: "نعم أو لا",
passFailNa: "ناجح أو فاشل أو لا ينطبق",
passFlagFail: "ناجح أو تنبيه أو فاشل",
level: "المستوى",
conditionRating: "تقييم الحالة",
stop: "إيقاف",
finishing: "جارٍ الإنهاء...",
dictate: "إملاء",
polishing: "جارٍ التحسين…",
generating: "جارٍ الإنشاء…",
polish: "تحسين",
generateDraft: "إنشاء مسودة",
previous: "السابق",
completeInspection: "إكمال الفحص",
nextItem: "البند التالي",
lastItem: "البند الأخير",
nextGroup: "المجموعة التالية",
lastGroup: "المجموعة الأخيرة",
nextUnanswered: "التالي بلا إجابة",
started: "بدأ {{when}}",
startedBy: "بدأ {{when}} · {{name}}",
},
viewModel: {
completionHintBlocking: "سيظهر زر «إكمال الفحص» بمجرد الإجابة عن العناصر المطلوبة أو تخطيها.",
completionHintFinalGroup: "سيظهر زر «إكمال الفحص» عند وصولك إلى المجموعة الأخيرة.",
completionHintLastItem: "سيظهر زر «إكمال الفحص» عند العنصر الأخير.",
completionHintOptionalRemain: "تبقّت عناصر اختيارية في قائمة التحقق — يمكنك الإنهاء بعد إكمال العناصر المطلوبة.",
},
pendingMedia: {
failedCaption_zero: "{{count}} لم يُرفع — اضغط لإعادة المحاولة",
failedCaption_one: "{{count}} لم يُرفع — اضغط لإعادة المحاولة",
failedCaption_two: "{{count}} لم يُرفع — اضغط لإعادة المحاولة",
failedCaption_few: "{{count}} لم يُرفع — اضغط لإعادة المحاولة",
failedCaption_many: "{{count}} لم يُرفع — اضغط لإعادة المحاولة",
failedCaption_other: "{{count}} لم يُرفع — اضغط لإعادة المحاولة",
pendingCaption_zero: "{{count}} محفوظة على هذا الجهاز، في انتظار الرفع",
pendingCaption_one: "{{count}} محفوظة على هذا الجهاز، في انتظار الرفع",
pendingCaption_two: "{{count}} محفوظة على هذا الجهاز، في انتظار الرفع",
pendingCaption_few: "{{count}} محفوظة على هذا الجهاز، في انتظار الرفع",
pendingCaption_many: "{{count}} محفوظة على هذا الجهاز، في انتظار الرفع",
pendingCaption_other: "{{count}} محفوظة على هذا الجهاز، في انتظار الرفع",
retryA11y: "إعادة محاولة رفع هذا الالتقاط",
pendingA11y: "تم حفظ الالتقاط على هذا الجهاز، بانتظار الرفع",
},
sideProgressPanel: {
sections: "الأقسام",
noSections: "لا توجد أقسام",
general: "عام",
},
findingsReview: {
  notAnswered_other: "{{count}} بند بلا إجابة",
  notAnswered_many: "{{count}} بندًا بلا إجابة",
  notAnswered_few: "{{count}} بنود بلا إجابة",
  notAnswered_two: "بندان بلا إجابة",
  notAnswered_one: "بند واحد بلا إجابة",
  notAnswered_zero: "لا شيء بلا إجابة",
  failedNeedJob_other: "{{count}} بند فاشل يحتاج إلى مهمة",
  failedNeedJob_many: "{{count}} بندًا فاشلًا يحتاج إلى مهمة",
  failedNeedJob_few: "{{count}} بنود فاشلة تحتاج إلى مهمة",
  failedNeedJob_two: "بندان فاشلان يحتاجان إلى مهمة",
  failedNeedJob_one: "بند فاشل واحد يحتاج إلى مهمة",
  failedNeedJob_zero: "لا توجد بنود فاشلة تحتاج إلى مهمة",
reportArchived: "تم حفظ التقرير",
findingsNeedDecision_one: "عنصر واحد فاشل يحتاج إلى مهمة أو سبب لتركه.",
findingsNeedDecision_other: "{{count}} عنصر فاشل يحتاج إلى مهمة أو سبب لتركه.",
noFindingsNeedFollowUp: "لا توجد نتائج تحتاج إلى متابعة.",
recommendedWorkPackages_one: "مهمة واحدة مقترحة من النتائج.",
recommendedWorkPackages_other: "{{count}} مهمة مقترحة من النتائج.",
allClear: "جميع العناصر التي تم فحصها سليمة.",
successfulItemsTitle: "العناصر الناجحة · {{count}}",
successfulItemsSummary: "العناصر التي نجحت ولا تحتاج إلى أي إجراء",
notRated: "غير مصنف",
answerItem: "إعادة الفتح للإجابة",
planWork: "تأكيد المهمة",
decisionA11y: "{{label}}: {{itemLabel}}",
uncertain: "بلا إجابة",
urgentFinding: "نتيجة عاجلة",
failedFinding: "بند فاشل",
findingsNeedDecision_zero: "لا نتائج تحتاج إلى قرار.",
findingsNeedDecision_two: "عنصران فاشلان يحتاجان إلى مهمة أو سبب لتركهما.",
findingsNeedDecision_few: "{{count}} عناصر فاشلة تحتاج إلى مهمة أو سبب لتركها.",
findingsNeedDecision_many: "{{count}} عنصرًا فاشلًا يحتاج إلى مهمة أو سبب لتركه.",
recommendedWorkPackages_zero: "لا مهام مقترحة من النتائج.",
recommendedWorkPackages_two: "مهمتان مقترحتان من النتائج.",
recommendedWorkPackages_few: "{{count}} مهام مقترحة من النتائج.",
recommendedWorkPackages_many: "{{count}} مهمةً مقترحةً من النتائج.",
},
vision: {
findingsGroup: "ملاحظات إضافية",
keepWorking: "متابعة العمل",
scan: {
group: "مسح",
item: "مسح",
groupHint: "يمكن لـ Vision المساعدة في {{count}} من أصل {{total}} فحوصات",
recommendedHint: "موصى به: امسح هذا القسم أولاً",
resultsReady: "النتائج جاهزة",
analysing: "جارٍ التحليل…",
open: "فتح المسح",
removeFinding: "إزالة الملاحظة",
supportedByEvidence: "مدعوم بدليل مرئي",
cameraAssisted: "بمساعدة الكاميرا، دون الاحتفاظ بصورة",
},
walk: {
  cardActionUpload: "إضافة صور",
  cardTitleUpload: "افحص المكان من الصور",
cardTitle: "تجوّل بالكاميرا",
cardBody: "يمكن لـ Vision الإجابة عن {{count}} من أصل {{total}} فحوصات مما يراه ويملؤها. تراجع فقط ما لم يستطع رؤيته أو لم يكن متأكدًا منه.",
cardAction: "بدء الجولة",
howTo: "اضغط الزر الأحمر، ثم امشِ ببطء وتوقف قليلًا عند كل بند في القائمة.",
walking: "جارٍ المسح… امشِ ببطء وتوقف عند كل بند. اضغط إنهاء عندما تنتهي من الجولة.",
start: "بدء الجولة",
stop: "إيقاف الجولة مؤقتًا",
uploadTitle: "أضف صورًا من أرجاء الغرفة",
autoFilled: "مُلئت نيابةً عنك: {{count}}",
rushedTitle: "كان ذلك سريعًا",
rushedBody: "غطيت {{total}} بنود في {{taken}} ث. توقف نحو ثانيتين عند كل بند (نحو {{suggested}} ث إجمالًا) ليرى Vision كل شيء بوضوح.",
keepScanning: "متابعة المسح",
finishAnyway: "إنهاء على أي حال",
slowDown: "تمهّل وثبّت الهاتف",
},
capture: {
title: "مسح",
uploadTitle: "إضافة صور للمسح",
manual: "الإجابة يدويًا",
moveSlowly: "التقط بضع صور واضحة لما يفحصه هذا القسم.",
damageTip: "اقترب وصوّر على امتداد اللوح بزاوية منخفضة — تظهر الانبعاجات في الانعكاسات.",
checklistToggle: "ما يجب تصويره · {{done}}/{{total}}",
checklistToggleNoCount: "ما يجب تصويره",
found: "تم العثور عليه",
removeFrameA11y: "إزالة الصورة {{index}}",
lowLight: "مطلوب إضاءة أكثر",
limitReached: "تم بلوغ الحد الأقصى للصور. أزل صورة لإضافة أخرى.",
costHint_zero: "لا يستهلك التحليل أي رصيد · المتاح {{balance}}",
costHint_one: "يستهلك التحليل رصيدًا واحدًا · المتاح {{balance}}",
costHint_two: "يستهلك التحليل رصيدين · المتاح {{balance}}",
costHint_few: "يستهلك التحليل {{count}} أرصدة · المتاح {{balance}}",
costHint_many: "يستهلك التحليل {{count}} رصيدًا · المتاح {{balance}}",
costHint_other: "يستهلك التحليل {{count}} رصيد · المتاح {{balance}}",
shutterA11y: "التقاط صورة",
finishCount: "إنهاء المسح ({{count}})",
cameraBlocked: "الوصول إلى الكاميرا متوقف. فعّله من الإعدادات أو أضف صورًا بدلاً من ذلك.",
cameraNeeded: "اسمح بالوصول إلى الكاميرا للمسح، أو أضف صورًا بدلاً من ذلك.",
openSettings: "فتح الإعدادات",
grant: "السماح بالكاميرا",
webNoLocal: "هنا يتحقق AssetWRX من الصور في السحابة. ستراجع كل شيء قبل حفظه.",
upload: "رفع الصور",
useCamera: "استخدام الكاميرا",
fromPhotos: "إضافة من الصور",
failed: "تعذّرت إضافة هذه الصورة. حاول مرة أخرى.",
seedFailed: "تعذّر فتح الصورة. التقط صورة جديدة أو أضف صورة من صورك.",
},
stage: {
reading_labels: "جارٍ قراءة الملصقات…",
checking_items: "جارٍ التحقق من بنود الفحص…",
reviewing_condition: "جارٍ مراجعة الحالة الظاهرة…",
preparing_results: "جارٍ تجهيز النتائج…",
},
coverage: {
observed: "تمت ملاحظته",
partial: "مرئي جزئيًا",
not_observed: "لم تتم ملاحظته",
},
cloud: {
offline: "أنت غير متصل، لذا تظهر نتائج الجهاز فقط.",
switched_off: "التحليل السحابي متوقف لمساحة العمل هذه. يظهر فقط ما تمكّن الجهاز من قراءته.",
nothing_to_scan: "لا شيء في هذا القسم يمكن قراءته من صورة. أجب عن عناصر الفحص بنفسك.",
no_credits: "رصيد الذكاء الاصطناعي غير كافٍ للتحليل السحابي. يظهر فقط ما تمكّن الجهاز من قراءته.",
timeout: "استغرق التحليل السحابي وقتًا طويلاً. يظهر فقط ما تمكّن الجهاز من قراءته.",
blocked_content: "تعذّر تحليل هذه الصور في السحابة. يظهر فقط ما تمكّن الجهاز من قراءته.",
failed: "لم يكتمل التحليل السحابي. يظهر فقط ما تمكّن الجهاز من قراءته.",
analyseNow: "التحليل بالذكاء الاصطناعي الآن · {{cost}}",
retry: "إعادة محاولة التحليل السحابي",
},
review: {
title: "مراجعة الاقتراحات",
emptyTitle: "تعذّر تحديد هذه الفحوصات من المسح",
emptyBody: "امسح مرة أخرى مع إظهار العنصر بوضوح، أو أجب عن الفحوصات بنفسك.",
summaryReady: "جاهزة: {{count}}",
summaryCheck: "للمراجعة: {{count}}",
summaryNotSeen: "غير مرئية: {{count}}",
summaryIssues: "مشكلات محتملة: {{count}}",
frameA11y: "صورة المسح {{index}}",
readyTitle: "جاهزة للتأكيد",
checkTitle: "راجع هذه",
notObservedTitle: "لم تتم ملاحظته",
issuesTitle: "مشكلات إضافية",
coverageTitle: "ما غطاه المسح",
acceptReady: "قبول الإجابات الجاهزة ({{count}})",
bulkSaved: "الإجابات المحفوظة: {{count}}",
undo: "تراجع",
done: "تم",
scanAgain: "المسح مرة أخرى",
completeManually: "الإجابة يدوياً",
leaveTitle: "المغادرة دون مراجعة؟",
leaveBody: "لم تتم مراجعة بعض الاقتراحات من هذا المسح. إذا غادرت الآن فسيتم تجاهلها.",
keepReviewing: "متابعة المراجعة",
discard: "تجاهل",
observed: "تمت ملاحظته",
suggested: "مقترح",
differs: "يختلف عن إجابتك. القبول يستبدلها.",
partial: "مرئي جزئيًا فقط. راجعه قبل القبول.",
conflict: "القراءات غير متطابقة. اختر القيمة الصحيحة.",
previousReading: "آخر تسجيل: {{value}}",
backwards: "أقل من آخر قراءة مسجلة.",
unitMismatch: "يُسجَّل هذا العداد بوحدة {{unit}}.",
serialMismatch: "لا يطابق الرقم التسلسلي المسجل لهذا الأصل.",
accept: "قبول",
change: "تغيير",
reject: "رفض",
save: "حفظ",
possibleIssue: "مشكلة محتملة",
confirmIssue: "تأكيد المشكلة",
flagIssue: "تمييز للمراجعة",
noIssue: "لا توجد مشكلة",
decision: {
accepted: "تم الحفظ",
changed: "تم الحفظ مع تعديلك",
rejected: "لم يُستخدم",
fail: "أُضيف إلى الملاحظات الإضافية",
flag: "مُيّز في الملاحظات الإضافية",
dismissed: "تم التجاهل",
},
reason: {
not_observed: "غير ظاهر في الصور.",
partial: "ظاهر جزئيًا فقط.",
low_confidence: "غير واضح بما يكفي لاقتراح إجابة.",
no_evidence: "لا شيء في المسح يجيب عن هذا.",
},
},
defect: {
corrosion: "تآكل",
leak: "تسرّب",
crack: "تشقق",
wear: "اهتراء",
deformation: "تشوّه",
missing_component: "مكوّن مفقود",
loose_component: "مكوّن مرتخٍ",
damage: "تلف",
contamination: "تلوّث",
damp_staining: "بقع رطوبة",
mould_growth: "نمو يشبه العفن",
blockage: "انسداد",
overheating: "ارتفاع الحرارة",
dent: "انبعاج",
scratch: "خدش",
paint_damage: "تلف في الطلاء",
glazing_damage: "تلف في الزجاج",
light_damage: "تلف في المصباح",
tyre_damage: "تلف في الإطار",
cable_damage: "تلف في الكابل",
exposed_wiring: "أسلاك مكشوفة",
misalignment: "عدم محاذاة",
blocked_access: "منفذ مسدود",
other_visible_anomaly: "شيء يحتاج إلى فحص",
},
trainingShare: {
title: "بيانات تحسين Vision",
body: "يحتفظ Vision بسجل الاقتراحات التي قبلها فريقك أو غيّرها أو رفضها، دون صور، لقياس دقته. هذا الإعداد مفعّل افتراضيًا: تُستخدم أيضًا صور الأدلة التي احتفظ بها فريقك لتلك الاقتراحات في تدريب Vision. تُنسخ إلى Google Cloud داخل الاتحاد الأوروبي للتدريب وتُحذف من هناك خلال 30 يومًا. يؤدي الإيقاف إلى منع أي استخدام لاحق؛ ولا يُلغى تدريب نموذج سبق تدريبه بها. تُحفظ السجلات لمدة 24 شهرًا.",
toggle: "استخدام صور الأدلة لدينا لتحسين Vision",
on: "مفعّل. قد تُنسخ صور الأدلة الخاصة بالاقتراحات المراجَعة إلى Google Cloud (الاتحاد الأوروبي) لتدريب Vision.",
off: "متوقف. تُحفظ قرارات المراجعة فقط، دون صور.",
failed: "تعذّر تغيير هذا الإعداد. حاول مرة أخرى.",
retry: "إعادة المحاولة",
},
},
ratingScale: {
poor: "ضعيف",
fair: "مقبول",
good: "جيد",
veryGood: "جيد جدًا",
excellent: "ممتاز",
low: "منخفض",
quarter: "ربع",
half: "نصف",
threeQuarter: "ثلاثة أرباع",
full: "ممتلئ",
},
};
